import React from "react";

export const project1cz = {
  name: "project1",
  title: `Evropské vegetační syntézy`,
  body: (
    <div>
      <div>
        <h3>Koordinátor</h3> Milan Chytrý (chytry@sci.muni.cz)
      </div>
      <br />
      <div>
        <h3>Spolupracovníci </h3> 
		Irena Axmanová, Gianmaria Bonari, Jiří
        Danihelka, Jan Divíšek, Pavel Dřevojan, Michal Hájek, Ondřej Hájek, Dana Holubová, Anni
        Jašková, Borja Jiménez-Alfaro, Martin Jiroušek, Veronika Kalníková, Veronika Kalusová, Ilona
        Knollová, Anna Kuzemko, Flavia Landucci, Zdeňka Lososová, Corrado Marcenò, Pavel Novák,
        Josep Padulles Cubino, Tomáš Peterka, Zdenka Preislerová, Marcela Řezníčková, Eva Šmerdová,
        Petra Štěpánková, Jakub Těšitel, Lubomír Tichý, Martin Večeřa, Denys Vynokurov, Viktoria
        Wagner, Dominik Zukal
      </div>
      <br />

      <div>
        <h3>Další spolupracovníci</h3> Členové IAVS Working Group European Vegetation
        Survey
      </div>

      <br />
      <div>
        <h3>Finanční podpora</h3>
        <li>
          2019–2023: Grantová agentura České republiky, EXPRO Centrum pro evropské vegetační syntézy, grant
          č. 19-28491X
        </li>
		<li>
          2017–2019: Grantová agentura České republiky, projekt Expertní systémy nové generace pro klasifikaci vegetace v kontinentálním měřítku, grant č. 17-15168S
        </li>
		<li>
          2014–2018: Grantová agentura České republiky, Centrum excelence Pladias, grant č. 14-36079G
        </li>
        
        
      </div>
      <br />
      <div>
        <h3>Cíle projektu</h3>
        <div>
          Naše pracovní skupina koordinuje {" "}
          <a href="http://euroveg.org/eva-database">Evropský vegetační archiv (EVA)</a>, integrovanou databázi fytocenologických snímků, která byla zřízena v roce 2012 ve spolupráci s kolegy z mezinárodní pracovní skupiny European Vegetation Survey při Mezinárodní společnosti pro výzkum vegetace (IAVS). Tento datový zdroj používáme pro analýzy různých aspektů diverzity evropské flóry a vegetace a vyvíjíme metody a nástroje pro podobné analýzy. Kromě toho provádíme vlastní terénní výzkum vegetace v různých částech Evropy. Soustředíme se zejména na: {" "}
          <li>vývoj typologie evropských biotopů jako nástroje pro ochranu přírody</li>
          <li>
            revize klasifikačního systému evropské vegetace s využitím rozsáhlých databází fytocenologických snímků
          </li>
          <li>
            mapování variability maloplošné druhové diverzity evropské vegetace a vysvětlování příčin této variability
          </li>
          <li>
            výzkum fylogenetické a funkční diverzity evropské vegetace
          </li>
          <li>hodnocení rostlinných invazí v evropské vegetaci</li>
          <li>vývoj infrastruktury, metod a nástrojů pro tento výzkum</li>
        </div>
      </div>
      <br />
      <div className="main-results">
        <h3>Hlavní výsledky</h3>
        <p>
          <b>Vegetační databáze</b>
		 <div> 
    Založili jsme Evropský vegetační archiv (EVA; Chytrý et al. 2016) a vytvořili několik tématických databází evropské vegetace (např. Landucci et al. 2015, Peterka et al. 2015, Marcenò & Jiménez-Alfaro 2017, Kalníková & Kudrnovsky 2017, Bonari et al. 2018, Jašková et al. 2020). Také dodáváme data do celosvětové vegetační databáze sPlot (Bruelheide et al. 2019).
		</div>
		</p>
        <p>
          <b>Metody analýzy vegetace a software</b>
        <div>
		Vyvinuli jsme různé metody pro statistické analýzy velkých vegetačních databází. Velká část těchto metod je dostupná v programu <a href="https://www.sci.muni.cz/botany/juice/">JUICE</a> Lubomíra Tichého. V poslední době jsme se zaměřili zejména na vývoj nových funkcí pro expertní systémy pro klasifikaci vegetace (Landucci et al. 2015, Tichý et al. 2019) a další nástroje pro automatické určování vegetačních typů (Tichý & Chytrý 2019).
        </div>
		</p>
		<p>
          <b>Klasifikace evropské vegetace</b>
        <div>
        Účastnili jsme se přípravy standardního seznamu evropské vegetace, tzv. EuroVegChecklistu (Mucina et al. 2016). Dále jsme se podíleli na několika studiích, které na základě analýzy velkých souborů fytocenologických snímků vytvořily formalizované klasifikace vybraných vegetačních typů pro celou Evropu nebo velkou část našeho kontinentu (např. Douda et al. 2016, Rodríguez-Rojo et al. 2017, Willner et al. 2017, 2019); některé z těchto studií byly koordinovány naším týmem (e.g. Peterka et al. 2017, Marcenò et al. 2018, Landucci et al. 2020, Novák et al. 2020).
        </div>
		</p>
		<p>
          <b>Evropské biotopy</b>
        <div>
        Pro Evropskou agenturu životního prostředí pracujeme na revizi a parametrizaci evropské standardní klasifikace biotopů EUNIS (Schaminée et al. 2012, 2013, 2014, 2016a, 2016b, 2018, 2019, 2020). Předběžná verze této revize byla použita v Evropském červeném seznamu biotopů (Janssen et al. 2016), na jehož tvorbě jsme se také podíleli. Vyvinuli jsme klasifikační expertní systém pro revidované typy biotopů EUNIS a vytvořili jsme seznamy jejich indikačních druhů a mapy rozšíření, které jsou významné pro praktické využití této klasifikace biotopů v ochranářském plánování, monitorování a rozhodování v Evropské unii i mimo ni.
        </div>
		</p>
		<p>
          <b>Maloplošná diverzita vegetačních typů</b>
        <div>
        Vyvinuli jsme techniku pro mapování maloplošné diverzity vegetace s využitím fytocenologických snímků (Divíšek & Chytrý 2018), zmapovali jsme druhové bohatství evropských lesů (Večeřa et al. 2019) a modelovali jsme druhové bohatství evropských bučin (Jiménez-Alfaro et al. 2018). Také jsme provedli dokumentaci extrémně druhově bohaté travinné vegetace v Karpatech a okolí (Chytrý et al. 2015, Roleček et al. 2019).
        </div>
		</p>
		<p>
          <b>Invaze nepůvodních druhů rostlin v evropské vegetaci</b>
        <div>
        Provedli jsme detailní vyhodnocení invazí nepůvodních druhů rostlin ve všech hlavních typech evropských lesů (Wagner et al. 2017). Také se zabýváme výměnami nepůvodních druhů mezi Evropou a jinými kontinenty v rámci analogických vegetačních typů v původním a nepůvodním areálu (Kalusová et al. 2014, 2015, 2017).
      </div>
	  </p>
	  </div>
      <div className="project-publication">
        <div>
          <h3>Odborné publikace (výběr)</h3>
        </div>
        <b>2020</b>
		<li>
		Giulio S., Acosta A.T.R., Carboni M., Campos J.A., <b>Chytrý M.</b>, Loidi J., Pergl J., Pyšek P., Isermann M., Janssen J.A.M., Rodwell J.S., Schaminée J.H.J. & Marcenò C. (2020): Alien flora across European coastal dunes. <i>Applied Vegetation Science</i> 23: 317–327. – <a href="https://doi.org/10.1111/avsc.12490">https://doi.org/10.1111/avsc.12490</a>
</li>
		  <li>
Küzmič F., Šilc U., <b>Lososová Z.</b>, Mucina L., <b>Chytrý M.</b>, <b>Knollová I.</b>, Hennekens S.M., Berg C., Bergmeier E., Biurrun I., Fanfarillo E., Font X., Iakushenko D., Kovačević Z., Meyer S., Nagy K., Pinke G., Poranen E. & Tereshenko S. (2020): European Weed Vegetation Database – a gap-focused vegetation-plot database. <i>Phytocoenologia</i> 50: 93–100. – <a href="https://doi.org/10.1127/phyto/2019/0337">https://doi.org/10.1127/phyto/2019/0337</a>
         </li>
		<li>
          Gholizadeh H., Naqinezhad A. &amp; <b>Chytrý M.</b> (2020): Classification of the Hyrcanian
          forest vegetation, northern Iran. <i>Applied Vegetation Science</i> 23: 107–126. –
		  <a href="https://doi.org/10.1111/avsc.12469">https://doi.org/10.1111/avsc.12469</a>          
		  </li>
		  <li>
		  <b>Jašková A.</b>, Braslavskaya T.Yu., Tikhonova E., Paal J.,
          Rūsiņa S., Laiviņš M., Kucherov I.B., Genikova N.V., <b>Knollová I.</b>, Chernenkova T.V.,
          Churakova E.Yu., Diekmann M., Halvorsen R., Kirichok E.I., Korotkov V.N., Kryshen A.M.,
          Lugovaya D.L., Morozova O.V., Potapov P.V., Prokazina T.S., Schei F.H., Semenishchenkov
          Yu.A., Shevchenko N.E., Sidorova O.V., Smirnov N.S., Smirnova O.V., Tsvirko R., Turubanova
          S.A. &amp; <b>Chytrý M.</b> (2020): European Boreal Forest Vegetation Database. <i>Phytocoenologia</i> 50: 79–92.
          –
          <a href="https://doi.org/10.1127/phyto/2019/0336">
            https://doi.org/10.1127/phyto/2019/0336
          </a>
        </li>
		<li>
		<b>Landucci F.</b>, Šumberová K., <b>Tichý L.</b>, Hennekens S., Aunina L., Biță‐Nicolae C., Borsukevych L., Bobrov A., Čarni A., De Bie E., Golub V., Hrivnák R., Iemelianova S., Jandt U., Jansen F., Kącki Z., Lájer K., Papastergiadou E., Šilc U., Sinkevičienė Z., Stančić Z., Stepanovič J., Teteryuk B., Tzonev R., Venanzoni R., Zelnik I. & <b>Chytrý M.</b> (2020): Classification of the European marsh vegetation (Phragmito‐Magnocaricetea) to the association level. <i>Applied Vegetation Science</i> 23: 297–316. – <a href="https://doi.org/10.1111/avsc.12484">
            https://doi.org/10.1111/avsc.12484
          </a>
		</li>
		<li>
<b>Novák P.</b>, Willner W., <b>Zukal D.</b>, Kollár J., <b>Roleček J.</b>, Świerkosz K., Ewald J., Wohlgemuth T., Csiky J., Onyshchenko V. & <b>Chytrý M.</b> (2020): Oak-hornbeam forests in central Europe: a formalized classification and syntaxonomic revision. <i>Preslia</i> 92: 1–34. – <a href="https://doi.org/10.23855/preslia.2020.001">
            https://doi.org/10.23855/preslia.2020.001
          </a>
</li>
		<li>
		Schaminée J.H.J., <b>Chytrý M.</b>, Hennekens S.M., Janssen J.A.M., <b>Knollová I.</b>, <b>Lososová Z.</b>, <b>Marcenò C.</b>, <b>Tichý L.</b> & data providers (2020): Updated crosswalks, formal query routines and indicator species of the revised EUNIS Habitat Classification with the European Vegetation Classification for vegetated man-made habitats and aligning of crosswalks between European Red List habitats and Annex I habitats with crosswalks between EUNIS habitats and Annex I habitats. Report EEA/NSS/17/002/Lot 1. European Environment Agency, Copenhagen. 
		 – <a href="https://www.sci.muni.cz/botany/chytry/Schaminee_etal2020_EEA-Report-Man-Made-Habitats.pdf">
		PDF
		</a>
		</li>
        <b>2019</b>
        <li>
          Bonari G., <b>Knollová I.</b>, <b>Vlčková P.</b>, Xystrakis F., Çoban S., Sağlam C., Didukh Y.P.,
          Hennekens S.M., Acosta A.T.R., Angiolini C., Bergmeier E., Bertacchi A., Costa J.C.,
          Fanfarillo E., Gigante D., Guarino R., Landi M., Neto C.S., Pesaresi S., Rosati L., Selvi
          F., Sotiriou A., Stinca A., Turcato C., Tzonev R., Viciani D. &amp; <b>Chytrý M.</b> (2019):
          CircumMed Pine Forest Database: an electronic archive for Mediterranean and
          Submediterranean pine forest vegetation data. <i>Phytocoenologia</i> 49: 311–318. – {" "}
		  <a href="https://doi.org/10.1127/phyto/2019/0311">https://doi.org/10.1127/phyto/2019/0311</a>
        </li>
        <li>
          Bruelheide H., Dengler J., Jiménez‐Alfaro B., Purschke O., Hennekens S. M., <b>Chytrý M.</b>,
          Pillar V. D., Jansen F., Kattge J., Sandel B., Aubin I., Biurrun I., Field R., Haider S.,
          Jandt U., Lenoir J., Peet R. K., Peyre G., Sabatini F. M., Schmidt M., Schrodt F., Winter
          M., Aćić S., Agrillo E., Alvarez M., Ambarlı D., Angelini P., Apostolova I., Arfin Khan M.
          A., Arnst E., Attorre F., Baraloto C., Beckmann M., Berg C., Bergeron Y., Bergmeier E.,
          Bjorkman A. D., Bondareva V., Borchardt P., Botta‐Dukát Z., Boyle B., Breen A., Brisse H.,
          Byun C., Cabido M. R., Casella L., Cayuela L., Černý T., Chepinoga V., Csiky J., Curran
          M., Ćušterevska R., Dajić Stevanović Z., De Bie E., De Ruffray P., De Sanctis M.,
          Dimopoulos P., Dressler S., Ejrnæs R., El‐Sheikh M. A. E. M., Enquist B., Ewald J.,
          Fagúndez J., Finckh M., Font X., Forey E., Fotiadis G., García‐Mijangos I., de Gasper A.
          L., Golub V., Gutierrez A. G., Hatim M. Z., He T., Higuchi P., <b>Holubová D.</b>, Hölzel N.,
          Homeier J., Indreica A., Isık Gürsoy D., Jansen S., Janssen J., Jedrzejek B., <b>Jiroušek M.</b>,
          Jürgens N., Kącki Z., Kavgacı A., Kearsley E., Kessler M., <b>Knollová I.</b>, Kolomiychuk V.,
          Korolyuk A., Kozhevnikova M., Kozub Ł., Krstonošić D., Kühl H., Kühn I., Kuzemko A.,
          Küzmič F., <b>Landucci F.</b>, Lee M. T., Levesley A., <b>Li C.-F.</b>, Liu H., Lopez‐Gonzalez G.,
          Lysenko T., Macanović A., Mahdavi P., Manning P., <b>Marcenò C.</b>, Martynenko V., Mencuccini
          M., Minden V., Moeslund J. E., Moretti M., Müller J. V., Munzinger J., Niinemets Ü., Nobis
          M., Noroozi J., Nowak A., Onyshchenko V., Overbeck G. E., Ozinga W. A., Pauchard A.,
          Pedashenko H., Peñuelas J., Pérez‐Haase A., <b>Peterka T.</b>, Petřík P., Phillips O. L.,
          Prokhorov V., Rašomavičius V., Revermann R., Rodwell J., Ruprecht E., Rūsiņa S., Samimi
          C., Schaminée J. H. J., Schmiedel U., Šibík J., Šilc U., Škvorc Ž., Smyth A., Sop T.,
          Sopotlieva D., Sparrow B., Stančić Z., Svenning J.-C., Swacha G., Tang Z., Tsiripidis I.,
          Turtureanu P. D., Ugurlu E., Uogintas D., Valachovič M., Vanselow K. A., Vashenyak Y.,
          Vassilev K., Vélez‐Martin E., Venanzoni R., Vibrans A. C., Violle C., Virtanen R., von
          Wehrden H., Wagner V., Walker D. A., Wana D., Weiher E., Wesche K., Whitfeld T., Willner
          W., Wiser S., Wohlgemuth T., Yamalov S., Zizka G. &amp; Zverev A. (2019): sPlot – a new tool
          for global vegetation analyses. <i>Journal of Vegetation Science</i> 30: 161–186. – {" "}
		  <a href="https://doi.org/10.1111/jvs.12710">https://doi.org/10.1111/jvs.12710</a>
          
        </li>
        <li>
          <b>Chytrý K.</b>, <b>Novák P.</b>, <b>Kalníková V.</b>, <b>Večeřa M.</b>, <b>Prokešová H.</b>, <b>Dřevojan P.</b> &amp; <b>Chytrý M.</b>
          (2019): Dry grassland vegetation in the Transcarpathian Lowland (western Ukraine).
          <i> Tuexenia</i> 39: 335–355. – {" "}
		  <a href="https://doi.org/10.14471/2019.39.009">https://doi.org/10.14471/2019.39.009</a> 
        </li>
        <li>
          Gholizadeh H., Naqinezhad A. &amp; <b>Chytrý M.</b> (2019): Hyrcanian Forest Vegetation Database.
          <i> Phytocoenologia</i> 49: 209–210. – {" "}
		  <a href="https://doi.org/10.1127/phyto/2018/0315">https://doi.org/10.1127/phyto/2018/0315</a> 
        </li>
        <li>
          Mastrogianni A., Kallimanis A.S., <b>Chytrý M.</b> &amp; Tsiripidis I. (2019): Phylogenetic
          diversity patterns in forests of a putative refugial area in Greece: A community level
          analysis. <i>Forest Ecology and Management</i> 446: 226–237. – {" "}
		  <a href="https://doi.org/10.1016/j.foreco.2019.05.044">https://doi.org/10.1016/j.foreco.2019.05.044</a>
          
        </li>
        <li>
          <b>Novák P.</b>, <b>Zukal D.</b>, <b>Kalníková V.</b>, <b>Chytrý K.</b>, &amp; Kavgacı A. (2019): Ecology and
          syntaxonomy of Colchic forests in south-western Georgia (Caucasus region). <i>Phytocoenologia </i>
          49: 231–248. – {" "}
		  <a href="https://doi.org/10.1127/phyto/2019/0250">https://doi.org/10.1127/phyto/2019/0250</a>
        </li>
        <li>
          Pätsch R., <b>Jašková A.</b>, <b>Chytrý M.</b>, Kucherov I.B., Schaminée J.H.J., Bergmeier E. &amp;
          Janssen J.A.M. (2019): Making them visible and usable – vegetation‐plot observations from
          Fennoscandia based on historical species‐quantity scales. <i>Applied Vegetation Science</i> 22:
          465–473. – {" "}
		  <a href="https://doi.org/10.1111/avsc.12452">https://doi.org/10.1111/avsc.12452</a>
        </li>
        <li>
          <b>Roleček J.</b>, <b>Hájek M.</b>, <b>Dřevojan P.</b>, <b>Prokešová H.</b>, Fajmon K., <b>Těšitel J.</b>, <b>Daněk P.</b>, <b>Hájková
          P.</b>, Jongepierová I., <b>Novák P.</b>, Poluyanov A. V., Shumska N. V., &amp; Chorney I. I. (2019):
          Gradients, species richness and biogeographical links of steppe grasslands in Western
          Podolia (Ukraine). <i>Phytocoenologia</i> 49: 349–367. – {" "}
		  <a href="https://doi.org/10.1127/phyto/2019/0255">https://doi.org/10.1127/phyto/2019/0255</a>
        </li>
		<li>
		  Schaminée J.H.J., <b>Chytrý M.</b>, <b>Hájek M.</b>, Hennekens S.M., Janssen J.A.M., <b>Jiroušek M.</b>, <b>Knollová I.</b>, <b>Marcenò C.</b>, <b>Peterka T.</b>, Rodwell J.S., <b>Tichý L.</b> & data providers (2019): Updated crosswalks of the revised EUNIS Habitat Classification with the European Vegetation Classification and the European Red List Habitats for EUNIS coastal habitats and wetlands. Formal query routines and indicator species. Report EEA/NSS/17/002/Lot 1. European Environment Agency, Copenhagen.
		  </li>
        <li>
          Sporbert M., Bruelheide H., Seidler G., Keil P., Jandt U., Austrheim G., Biurrun I.,
          Campos J. A., Čarni A., <b>Chytrý M.</b>, Csiky J., Bie E. D., Dengler J., Golub V., Grytnes
          J.-A., Indreica A., Jansen F., <b>Jiroušek M.</b>, Lenoir J., Luoto M., <b>Marcenò C.</b>, Moeslund J.
          E., Pérez‐Haase A., Rūsiņa S., Vandvik V., Vassilev K. &amp; Welk E. (2019): Assessing
          sampling coverage of species distribution in biodiversity databases. <i>Journal of Vegetation
          Science</i> 30: 620–632. – {" "}
		  <a href="https://doi.org/10.1111/jvs.12763">https://doi.org/10.1111/jvs.12763</a> 
        </li>
        <li>
          <b>Tichý L.</b> &amp; <b>Chytrý M.</b> (2019): Probabilistic key for identifying vegetation types in the
          field: a new method and Android application. <i>Journal of Vegetation Science</i> 30: 1035–1038.
          – <a href="https://doi.org/10.1111/jvs.12799">https://doi.org/10.1111/jvs.12799</a> 
        </li>
        <li>
          <b>Tichý L.</b>, <b>Chytrý M.</b> &amp; <b>Landucci F.</b> (2019): GRIMP: A machine-learning method for
          improving groups of discriminating species in expert systems for vegetation
          classification. <i>Journal of Vegetation Science</i> 30: 5–17. – {" "}
		  <a href="https://doi.org/10.1111/jvs.12696">https://doi.org/10.1111/jvs.12696</a>
          
        </li>
        <li>
          <b>Večeřa M.</b>, <b>Divíšek J.</b>, Lenoir J., <b>Jiménez-Alfaro B.</b>, Biurrun I., <b>Knollová I.</b>, Agrillo E.,
          Campos J.A., Čarni A., Crespo Jiménez G., Ćuk M., Dimopoulos P., Ewald J.,
          Fernández-González F., Gégout J.-C., Indreica A., Jandt U., Jansen F., Kącki Z.,
          Rašomavičius V., <b>Řezníčková M.</b>, Rodwell J.S., Schaminée J.H.J., Šilc U., Svenning
          J.-C., Swacha G., Vassilev K., Venanzoni R., Willner W., Wohlgemuth T. &amp; <b>Chytrý M. </b>
          (2019): Alpha diversity of vascular plants in European forests. <i>Journal of Biogeography</i>
          46: 1919–1935. – {" "}
		  <a href="https://doi.org/10.1111/jbi.13624">https://doi.org/10.1111/jbi.13624</a> 
        </li>
        <li>
          Willner W., <b>Roleček J.</b>, Korolyuk A., Dengler J., <b>Chytrý M.</b>, Janišová M., Lengyel A., Aćić
          S., Becker T., Ćuk M., Demina O., Jandt U., Kącki Z., Kuzemko A., Kropf M., Lebedeva M.,
          Semenishchenkov Y., Šilc U., Stančić Z., Staudinger M., Vassilev K. &amp; Yamalov S.
          (2019): Formalized classification of semi-dry grasslands in central and eastern Europe.
          <i> Preslia</i> 91: 25–49. – {" "}
		  <a href="https://doi.org/10.23855/preslia.2019.025">https://doi.org/10.23855/preslia.2019.025</a> 
        </li>
        <b>2018</b>
        <li>
          Bruelheide H., Dengler J., Purschke O., Lenoir J., <b>Jiménez-Alfaro B.</b>, Hennekens S.M.,
          Botta-Dukát Z., <b>Chytrý M.</b>, Field R., Jansen F., Kattge J., Pillar V.D., Schrodt F.,
          Mahecha M.D., Peet R.K., Sandel B., van Bodegom P., Altman J., Alvarez-Dávila E., Arfin
          Khan M.A.S., Attorre F., Aubin I., Baraloto C., Barroso J.G., Bauters M., Bergmeier E.,
          Biurrun I., Bjorkman A.D., Blonder B., Čarni A., Cayuela L., Černý T., Cornelissen J.H.C.,
          Craven D., Dainese M., Derroire G., De Sanctis M., Díaz S., Doležal J., Farfan-Rios W.,
          Feldpausch T.R., Fenton N.J., Garnier E., Guerin G.R., Gutiérrez A.G., Haider S., Hattab
          T., Henry G., Hérault B., Higuchi P., Hölzel N., Homeier J., Jentsch A., Jürgens N., Kącki
          Z., Karger D.N., Kessler M., Kleyer M., <b>Knollová I.</b>, Korolyuk A.Y., Kühn I., Laughlin
          D.C., Lens F., Loos J., Louault F., Lyubenova M.I., Malhi Y., <b>Marcenò C.</b>, Mencuccini M.,
          Müller J.V., Munzinger J., Myers-Smith I.H., Neill D.A., Niinemets Ü., Orwin K.H., Ozinga
          W.A., Penuelas J., Pérez-Haase A., Petřík P., Phillips O.L., Pärtel M., Reich P.B.,
          Römermann C., Rodrigues A.V., Sabatini F.M., Sardans J., Schmidt M., Seidler G., Silva
          Espejo J.E., Silveira M., Smyth A., Sporbert M., Svenning J.-C., Tang Z., Thomas R.,
          Tsiripidis I., Vassilev K., Violle C., Virtanen R., Weiher E., Welk E., Wesche K., Winter
          M., Wirth C. &amp; Jandt U. (2018): Global trait–environment relationships of plant
          communities. <i><i>Nature Ecology &amp; Evolution</i></i> 2: 1906–1917. – {" "}
		  <a href="https://www.nature.com/articles/s41559-018-0699-8">https://www.nature.com/articles/s41559-018-0699-8</a>
          
        </li>
        <li>
          Del Vecchio S., Fantinato E., Janssen J. A. M., Bioret F., Acosta A., Prisco I., Tzonev
          R.,<b> <b>Marcenò C.</b></b>, Rodwell J. &amp; Buffa G. (2018): Biogeographic variability of coastal
          perennial grasslands at the European scale. <i>Applied Vegetation Science</i> 21: 312–321. – {" "}
		  <a href="https://doi.org/10.1111/avsc.12356">https://doi.org/10.1111/avsc.12356</a>
        </li>
        <li>
          <b>Divíšek J.</b> &amp; <b>Chytrý M.</b> (2018): High-resolution and large-extent mapping of plant
          species richness using vegetation-plot databases. <i>Ecological Indicators</i> 89: 840–851. – {" "}
		  <a href="https://doi.org/10.1016/j.ecolind.2017.11.005">https://doi.org/10.1016/j.ecolind.2017.11.005</a>
          
        </li>
        <li>
          <b>Jiménez-Alfaro B.</b>, Girardello M., <b>Chytrý M.</b>, Svenning J.-C., Willner W., Gégout J.-C.,
          Agrillo E., Campos J.A., Jandt U., Kącki Z., Šilc U., Slezák M., <b>Tichý L.</b>, Tsiripidis I.,
          Turtureanu P.D., Ujházyová M. &amp; Wohlgemuth T. (2018): History and environment shape
          species pools and community diversity in European beech forests. <i>Nature Ecology &amp;
          Evolution</i> 2: 483–490. – {" "}
		  <a href="http://dx.doi.org/10.1038/s41559-017-0462-6">http://dx.doi.org/10.1038/s41559-017-0462-6</a> 
        </li>
        <li>
          <b>Jiménez-Alfaro B.</b>, Suárez-Seoane S., <b>Chytrý M.</b>, Hennekens S.M., Willner W., <b>Hájek M.</b>,
          Agrillo E., Álvarez-Martínez J.M., Bergamini A., Brisse H., Brunet J., Casella L., Dítě
          D., Font X., Gillet F., <b>Hájková P.</b>, Jansen F., Jandt U., Kącki Z., Lenoir J., Rodwell
          J.S., Schaminée J.H.J., <b>Sekulová L.</b>, Šibík J., Škvorc Ž. &amp; Tsiripidis I. (2018):
          Modelling the distribution and compositional variation of plant communities at the
          continental scale. <i>Diversity and Distributions</i> 24: 978–990. – {" "}
		  <a href="https://doi.org/10.1111/ddi.12736">https://doi.org/10.1111/ddi.12736</a>
          
        </li>
        <li>
          <b>Marcenò C.</b>, Guarino R., Loidi J., Herrera M., Isermann M., <b>Knollová I.</b>, <b>Tichý L.</b>, Tzonev
          R.T., Acosta A.T.R., FitzPatrick Ú., Iakushenko D., Janssen J.A.M., <b>Jiménez-Alfaro B.</b>,
          Kącki Z., Keizer-Sedláková I., Kolomiychuk V., Rodwell J.S., Schaminée J.H.J., Šilc U.
          &amp; <b>Chytrý M.</b> (2018): Classification of European and Mediterranean coastal dune
          vegetation. <i>Applied Vegetation Science</i> 21: 533–559. – {" "}
		  <a href="https://doi.org/10.1111/avsc.12379">https://doi.org/10.1111/avsc.12379</a>
        </li>
        <li>
          Roces-Díaz J.V., <b>Jiménez-Alfaro B.</b>, <b>Chytrý M.</b>, Díaz-Varela E.R. &amp; Álvarez-Álvarez P.
          (2018): Glacial refugia and mid-Holocene expansion delineate the current distribution of
          Castanea sativa in Europe. <i>Palaeogeography, Palaeoclimatology, Palaeoecology</i> 491: 152–160. –{" "}
		  <a href="https://doi.org/10.1016/j.palaeo.2017.12.004">https://doi.org/10.1016/j.palaeo.2017.12.004</a> 
        </li>
        <li>
          Sabatini F.M., <b>Jiménez-Alfaro B.</b>, Burrascano S., Lora A. &amp; <b>Chytrý M.</b> (2018):
          Beta-diversity of Central European forests decreases along an elevational gradient due to
          the variation in local community assembly processes. <i>Ecography</i> 41: 1038–1048. – {" "}
		  <a href="http://dx.doi.org/10.1111/ecog.02809">http://dx.doi.org/10.1111/ecog.02809</a>
          
        </li>
        <li>
          Schaminée J.H.J., <b>Chytrý M.</b>, Hennekens S.M., Janssen J.A.M., <b>Knollová I.</b>, Rodwell J.S.,
          <b> Tichý L.</b> &amp; data providers (2018): Updated crosswalk of the revised EUNIS Habitat
          Classification with the European vegetation classification and indicator species for the
          EUNIS grassland, shrubland and forest types. Report EEA/NSS/17/002/Lot 1. European
          Environment Agency, Copenhagen.
        </li>
        <b>2017</b>
        <li>
          <b>Kalníková V.</b> &amp; Kudrnovsky H. (2017): Gravel Bar Vegetation Database. <i>Phytocoenologia </i>
          47: 109–110. – {" "}
		  <a href="https://doi.org/10.1127/phyto/2017/0177
">https://doi.org/10.1127/phyto/2017/0177
</a>
        </li>
        <li>
          <b><b>Kalusová V.</b></b>, <b>Chytrý M.</b>, van Kleunen M., Mucina L., Dawson W., Essl F., Kreft H., Pergl J.,
          Weigelt P., Winter M. &amp; Pyšek P. (2017): Naturalization of European plants on other
          continents: The role of donor habitats. <i>Proceedings of the National Academy of Sciences of
          the USA</i> 114: 13756–13761. – {" "}
		  <a href="http://dx.doi.org/10.1073/pnas.1705487114">http://dx.doi.org/10.1073/pnas.1705487114</a> 
        </li>
        <li>
          <b><b>Marcenò C.</b></b> &amp; <b>Jiménez-Alfaro B.</b> (2017): The Mediterranean Ammophiletea Database: a
          comprehensive dataset of coastal dune vegetation. <i>Phytocoenologia</i> 47: 95–105. – {" "}
		  <a href="http://doi.org/10.1127/phyto/2016/0133
">http://doi.org/10.1127/phyto/2016/0133
</a>
        </li>
        <li>
          <b>Novák P.</b>, <b>Zukal D.</b>, <b>Večeřa M.</b> &amp; <b>Píšťková K.</b> (2017): Vegetation of oak-hornbeam, scree
          and ravine forests at lower altitudes in Transcarpathia, Western Ukraine. <i>Tuexenia</i> 37: 47–63. – {" "}
		  <a href="http://doi.org/10.14471/2017.37.021
">http://doi.org/10.14471/2017.37.021
</a>
        </li>
        <li>
          <b>Peterka T.</b>, <b>Hájek M.</b>, <b>Jiroušek M.</b>, <b>Jiménez-Alfaro B.</b>, Aunina L., Bergamini A., Dítě D.,
          Felbaba- Klushyna L., Graf U., <b>Hájková P.</b>, <b>Hettenbergerová E.</b>, Ivchenko T.G., Jansen F.,
          Koroleva N.E., Lapshina E.D., Lazarević P.M., Moen A., Napreenko M.G., Pawlikowski P.,
          <b> Plesková Z.</b>, <b>Sekulová L.</b>, Smagin V.A., Tahvanainen T., Thiele A., Biţă-Nicolae C., Biurrun
          I., Brisse H., Ćušterevska R., De Bie E., Ewald J., FitzPatrick Ú., Font X., Jandt U.,
          Kącki Z., Kuzemko A., <b>Landucci F.</b>, Moeslund J.E., Pérez-Haase A., Rašomavičius V., Rodwell
          J.S., Schaminée J.H.J., Šilc U., Stančić Z. &amp; <b>Chytrý M.</b> (2017): Formalized
          classification of European fen vegetation at the alliance level. <i>Applied Vegetation
          Science</i> 20: 124–142. – {" "}
		  <a href="http://dx.doi.org/10.1111/avsc.12271">http://dx.doi.org/10.1111/avsc.12271</a> 
        </li>
        <li>
          Rodríguez-Rojo M.P., <b>Jiménez-Alfaro B.</b>, Jandt U., Bruelheide H., Rodwell J.S., Schaminée
          J.H.J., Perrin P.M., Kącki Z., Willner W., Fernández-González F. &amp; <b>Chytrý M.</b> (2017):
          Diversity of lowland hay meadows and pastures in Western and Central Europe. <i>Applied
          Vegetation Science</i> 20: 702–719. – {" "}
		  <a href="http://dx.doi.org/10.1111/avsc.12326">http://dx.doi.org/10.1111/avsc.12326</a> 
        </li>
        <li>
          Wagner V., <b>Chytrý M.</b>, <b>Jiménez-Alfaro B.</b>, Pergl J., Hennekens S., Biurrun I., <b>Knollová I.</b>,
          Berg C., Vassilev K., Rodwell J.S., Škvorc Ž., Jandt U., Ewald J., Jansen F., Tsiripidis
          I., Botta-Dukát Z., Casella L., Attorre F., Rašomavičius V., Ćušterevska R., Schaminée
          J.H.J., Brunet J., Lenoir J., Svenning J.-C., Kącki Z., Petrášová-Šibíková M., Šilc U.,
          García-Mijangos I., Campos J.A., Fernández-González F., Wohlgemuth T., Onyshchenko V.
          &amp; Pyšek P. (2017): Alien plant invasions in European woodlands. <i>Diversity and
          Distributions</i> 23: 969–981. –{" "}
		  <a href="http://dx.doi.org/10.1111/ddi.12592">http://dx.doi.org/10.1111/ddi.12592</a> 
        </li>
        <li>
          Willner W., <b>Jiménez-Alfaro B.</b>, Agrillo E., Biurrun I., Campos J.A., Čarni A., Casella L.,
          Csiky J., Ćušterevska R., Didukh Ya.P., Ewald J., Jandt U., Jansen F., Kącki Z., Kavgacı
          A., Lenoir J., Marinšek A., Onyshchenko V., Rodwell J., Schaminée J., Šibík J., Škvorc Ž.,
          Svenning J.-C., Tsiripidis J., Turtureanu P.D., Tzonev R., Vassilev K., Venanzoni R.,
          Wohlgemuth T. &amp; <b>Chytrý M.</b> (2017): Classification of European beech forests: a Gordian
          Knot? <i>Applied Vegetation Science</i> 20: 494–512. – {" "}
		  <a href="http://dx.doi.org/10.1111/avsc.12299">http://dx.doi.org/10.1111/avsc.12299</a>
        </li>
        <li>
          Willner W., Kuzemko A., Dengler J., <b>Chytrý M.</b>, Bauer N., Becker T., Biţă-Nicolae C.,
          Botta-Dukát Z., Čarni A., Csiky J., Igić R., Kącki Z., Korotchenko I., Kropf M.,
          Krstivojević-Ćuk M., Krstonošić D., Rédei T., Ruprecht E., Schratt-Ehrendorfer L.,
          Semenishchenkov Y., Stančić Z., Vashenyak Y., Vynokurov D. &amp; Janišová M. (2017): A
          higher-level classification of the Pannonian and western Pontic steppe grasslands (Central
          and Eastern Europe). <i>Applied Vegetation Science</i> 20: 143–158. –{" "}
		  <a href="http://dx.doi.org/10.1111/avsc.12265">http://dx.doi.org/10.1111/avsc.12265</a>
          
        </li>
        <b>2016</b>
        <li>
          <b>Chytrý M.</b>, Hennekens S.M., <b>Jiménez-Alfaro B.</b>, <b>Knollová I.</b>, Dengler J., Jansen F., <b>Landucci
          F.</b>, Schaminée J.H.J., Aćić S., Agrillo E., Ambarlı D., Angelini P., Apostolova I., Attorre
          F., Berg C., Bergmeier E., Biurrun I., Botta-Dukát Z., Brisse H., Campos J.A., Carlón L.,
          Čarni A., Casella L., Csiky J., Ćušterevska R., Dajić Stevanović Z., <b>Danihelka J.</b>, De Bie
          E., de Ruffray P., De Sanctis M., Dickoré W.B., Dimopoulos P., Dubyna D., Dziuba T.,
          Ejrnæs R., Ermakov N., Ewald J., Fanelli G., Fernández-González F., FitzPatrick Ú., Font
          X., García-Mijangos I., Gavilán R.G., Golub V., Guarino R., Haveman R., Indreica A., Işık
          Gürsoy D., Jandt U., Janssen J.A.M., <b>Jiroušek M.</b>, Kącki Z., Kavgacı A., Kleikamp M.,
          Kolomiychuk V., Krstivojević Ćuk M., Krstonošić D., Kuzemko A., Lenoir J., Lysenko T.,
          <b> Marcenò C.</b>, Martynenko V., <b>Michalcová D.</b>, Moeslund J.E., Onyshchenko V., Pedashenko H.,
          Pérez-Haase A., <b>Peterka T.</b>, Prokhorov V., Rašomavičius V., Rodríguez-Rojo M.P., Rodwell
          J.S., Rogova T., Ruprecht E., Rūsiņa S., Seidler G., Šibík J., Šilc U., Škvorc Ž.,
          Sopotlieva D., Stančić Z., Svenning J.-C., Swacha G., Tsiripidis I., Turtureanu P.D.,
          Uğurlu E., Uogintas D., Valachovič M., Vashenyak Y., Vassilev K., Venanzoni R., Virtanen
          R., Weekes L., Willner W., Wohlgemuth T. &amp; Yamalov S. (2016): European Vegetation
          Archive (EVA): an integrated database of European vegetation plots. <i>Applied Vegetation
          Science</i> 19: 173–180. – {" "}
		  <a href="https://doi.org/10.1111/avsc.12191
">https://doi.org/10.1111/avsc.12191
</a>
        </li>
        <li>
          Douda J., Boublík K., Slezák M., Biurrun I., Nociar J., Havrdová A., Doudová J., Aćić S.,
          Brisse H., Brunet J., <b>Chytrý M.</b>, Claessens H., Csiky J., Didukh Ya., Dimopoulos P.,
          Dullinger S., FitzPatrick Ú., Guisan A., Horchler P.J., Hrivnák R., Jandt U., Kącki Z.,
          Kevey B., <b>Landucci F.</b>, Lecomte H., Lenoir J., Paal J., Paternoster D., Pauli H., Pielech
          R., Rodwell J.S., Roelandt B., Svenning J.-C., Šibík J., Šilc U., Škvorc Ž., Tsiripidis
          I., Tzonev R.T., Wohlgemuth T. &amp; Zimmermann N.E. (2016): Vegetation classification and
          biogeography of European floodplain forests and alder carrs. <i>Applied Vegetation Science </i>
          19: 147–163.
        </li>
        <li>
          Janssen J.A.M., Rodwell J.S., García Criado M., Gubbay S., Haynes T., Nieto A., Sanders
          N., <b>Landucci F.</b>, Loidi J., Ssymank A., Tahvanainen T., Valderrabano M., Acosta A.,
          Aronsson M., Arts G., Attorre F., Bergmeier E., Bijlsma R.-J., Bioret F., Biţă-Nicolae C.,
          Biurrun I., Calix M., Capelo J., Čarni A., <b>Chytrý M.</b>, Dengler J., Dimopoulos P., Essl F.,
          Gardfjell H., Gigante D., Giusso del Galdo G., <b>Hájek M.</b>, Jansen F., Jansen J., Kapfer J.,
          Mickolajczak A., Molina J.A., Molnár Z., Paternoster D., Piernik A., Poulin B., Renaux B.,
          Schaminée J.H.J., Šumberová K., Toivonen H., Tonteri T., Tsiripidis I., Tzonev R. &amp;
          Valachovič M. (2016): European Red List of Habitats - Part 2. Terrestrial and freshwater
          habitats. Publications Office of the European Union, Luxembourg.
        </li>
        <li>
          Mucina L., Bültmann H., Dierßen K., Theurillat J.-P., Raus T., Čarni A., Šumberová K.,
          Willner W., Dengler J., Gavilán García R., <b>Chytrý M.</b>, <b>Hájek M.</b>, Di Pietro R., Iakushenko
          D., Pallas J., Daniëls F.J.A., Bergmeier E., Santos Guerra A., Ermakov N., Valachovič M.,
          Schaminée J.H.J., Lysenko T., Didukh Ya.P., Pignatti S., Rodwell J.S., Capelo J., Weber
          H.E., Solomeshch A., Dimopoulos P., Aguiar C., Hennekens S.M. &amp; <b>Tichý L.</b> (2016):
          Vegetation of Europe: Hierarchical floristic classification system of vascular plant,
          bryophyte, lichen, and algal communities. <i>Applied Vegetation Science</i> 19, Suppl. 1: 3–264.
        </li>
        <li>
          Schaminée J.H.J., <b>Chytrý M.</b>, Hennekens S.M., Janssen J.A.M., <b>Jiménez-Alfaro B.</b>, <b>Knollová
          I.</b>, <b>Marceno C.</b>, Mucina L., Rodwell J.S., <b>Tichý L.</b> &amp; data-providers (2016a): Review of
          grassland habitats and development of distribution maps of heathland, scrub and tundra
          habitats of EUNIS habitats classification. Report EEA/NSV/15/005. European Environment
          Agency, Copenhagen.
        </li>
        <li>
          Schaminée J.H.J., <b>Chytrý M.</b>, Dengler J., Hennekens S.M., Janssen J.A.M., <b>Jiménez-Alfaro
          B.</b>, <b>Knollová I.</b>, <b>Landucci F.</b>, <b>Marcenò C.</b>, Rodwell J.S., <b>Tichý L.</b> &amp; data-providers
          (2016b): Development of distribution maps of grassland habitats of EUNIS habitat
          classification. Report EEA/NSV/16/005. European Environment Agency, Copenhagen.
        </li>
        <li>
          Ujházyová M., Ujházy K., <b>Chytrý M.</b>, Willner W., Čiliak M., Máliš F. &amp; Slezák M.
          (2016): Diversity of beech forest vegetation in the Eastern Alps, Bohemian Massif and the
          Western Carpathians. <i>Preslia</i> 88: 435–457.
        </li>
        <b>2015</b>
        <li>
          <b>Chytrý M.</b>, Dražil T., <b>Hájek M.</b>, <b>Kalníková V.</b>, <b>Preislerová Z.</b>, Šibík J., Ujházy K.,
          <b> Axmanová I.</b>, Bernátová D., Blanár D., Dančák M., <b>Dřevojan P.</b>, Fajmon K., Galvánek D.,
          <b> Hájková P.</b>, Herben T., Hrivnák R., Janeček Š., Janišová M., Jiráská Š., Kliment J.,
          Kochjarová J., Lepš J., Leskovjanská A., <b>Merunková K.</b>, Mládek J., Slezák M., Šeffer J.,
          Šefferová V., Škodová I., Uhlířová J., Ujházyová M. &amp; <b>Vymazalová M.</b> (2015): The most
          species-rich plant communities in the Czech Republic and Slovakia (with new world
          records). <i>Preslia</i> 87: 217–278. – {" "}
		  <a href="http://www.preslia.cz/2015.html#chytry
">PDF
</a>
        </li>
        <li>
          De Cáceres M., <b>Chytrý M.</b>, Agrillo E., Attorre F., Botta-Dukát Z., Capelo J., Czúcz B.,
          Dengler J., Ewald J., Faber-Langendoen D., Feoli E., Franklin S.B., Gavilán R., Gillet F.,
          Jansen F., <b>Jiménez-Alfaro B.</b>, Krestov P., <b>Landucci F.</b>, Lengyel A., Loidi J., Mucina L.,
          Peet R.K., Roberts D.W., <b>Roleček J.</b>, Schaminée J.H.J., Schmidtlein S., Theurillat J.-P.,
          <b> Tichý L.</b>, Walker D.A., Wildi O., Willner W. &amp; Wiser S.K. (2015): A comparative
          framework for broad-scale plot-based vegetation classification. <i>Applied Vegetation Science </i>
          18: 543–560.
        </li>
        <li>
          <b>Jiménez-Alfaro B.</b>, <b>Marcenò C.</b>, Guarino R. &amp; <b>Chytrý M.</b> (2015): Regional metacommunities
          in two coastal systems: spatial structure and drivers of plant assemblages. <i>Journal of
          Biogeography</i> 42: 452–462.
        </li>
        <li>
          <b><b>Kalusová V.</b></b>, <b>Chytrý M.</b>, Peet R.K. &amp; Wentworth T.R. (2015): Intercontinental comparison
          of habitat levels of invasion between temperate North America and Europe. <i>Ecology</i> 96:
          3363–3373.
        </li>
        <li>
          <b>Landucci F.</b>, <b>Řezníčková M.</b>, Šumberová K., <b>Chytrý M.</b>, Aunina L., Biţă-Nicolae C., Bobrov
          A., Borsukevych L., Brisse H., Čarni A., Csiky J., Cvijanović D., De Bie E., De Ruffray
          P., Dubyna D., Dimopoulos P., Dziuba T., FitzPatrick Ú., Font X., Gigante D., Golub V.,
          Hennekens S.M., Hrivnák R., Iemelianova S., Jandt U., Jenačković D., Jansen F., Kącki Z.,
          Lájer K., Matulevičiutė D., Mesterházy A., <b>Michalcová D.</b>, Paal J., Papastergiadou E.,
          Properzi A., Radulović S., Rodwell J.S., Schaminée J.H.J., Šilc U., Sinkevičienė Z.,
          Stančić Z., Stepanovich J., Teteryuk B., Tzonev R., Venanzoni R., Weekes L. &amp; Willner
          W. (2015): WetVegEurope: a database of aquatic and wetland vegetation of Europe.
          <i> Phytocoenologia</i> 45: 187–194.
        </li>
        <li>
          <b>Landucci F.</b>, <b>Tichý L.</b>, Šumberová K. &amp; <b>Chytrý M.</b> (2015): Formalized classification of
          species-poor vegetation: a proposal of a consistent protocol for aquatic vegetation.
          <i> Journal of Vegetation Science</i> 26: 791–803.
        </li>
        <li>
          <b>Palpurina S.</b>, <b>Chytrý M.</b>, Tzonev R., <b>Danihelka J.</b>, <b>Axmanová I.</b>, <b>Merunková K.</b>, <b>Duchoň M. </b>
          &amp; Karakiev T. (2015): Patterns of fine-scale plant species richness in dry grasslands
          across the eastern Balkan Peninsula. <i>Acta Oecologica</i> 63: 36–46.
        </li>
        <li>
          <b>Peterka T.</b>, <b>Jiroušek M.</b>, <b>Hájek M.</b> &amp; <b>Jiménez-Alfaro B.</b> (2015): European Mire Vegetation
          Database: a gap-oriented database for European fens and bogs. <i>Phytocoenologia</i> 45: 291–298.
        </li>
        <b>2014</b>
        <li>
          <b>Jiménez-Alfaro B.</b>, <b>Chytrý M.</b>, Rejmánek M. &amp; Mucina L. (2014): The number of vegetation
          types in European countries: major determinants and extrapolation to other regions.
          <i> Journal of Vegetation Science</i> 25: 863–872.
        </li>
        <li>
          <b><b>Kalusová V.</b></b>, <b>Chytrý M.</b>, Peet R.K. &amp; Wentworth T.R. (2014): Alien species pool
          influences the level of habitat invasion in intercontinental exchange of alien plants.
          <i> Global Ecology and Biogeography</i> 23: 1366–1375.
        </li>
        <li>
          Rodríguez-Rojo M.P., Fernández-González F., <b>Tichý L.</b> &amp; <b>Chytrý M.</b> (2014): Vegetation
          diversity of mesic grasslands (Arrhenatheretalia) in the Iberian Peninsula. <i>Applied
          Vegetation Science</i> 17: 780–796.
        </li>
        <li>
          Schaminée J.H.J., <b>Chytrý M.</b>, Hennekens S.M., Janssen J.A.M., <b>Jiménez-Alfaro B.</b>, <b>Knollová
          I.</b>, Mucina L., Rodwell J.S., <b>Tichý L.</b> &amp; data-providers (2014): Vegetation analysis and
          distribution maps for EUNIS habitats. Report EEA/NSV/14/006. European Environment Agency,
          Copenhagen.
        </li>
        <li>
          <b>Tichý L.</b>, <b>Chytrý M.</b> &amp; Botta-Dukát Z. (2014): Semi-supervised classification of
          vegetation: preserving the good old units and searching for new ones. <i>Journal of
          Vegetation Science</i> 25: 1504–1512.
        </li>
        <b>2013</b>
        <li>
          <b>Landucci F.</b>, Venanzoni R., Gigante D. &amp; <b>Chytrý M.</b> (2013): Wetland vegetation of the
          class Phragmito- Magno-Caricetea in central Italy. <i>Phytocoenologia</i> 43: 67–100.
        </li>
        <li>
          Schaminée J.H.J., <b>Chytrý M.</b>, Hennekens S.M., <b>Jiménez-Alfaro B.</b>, Mucina L., Rodwell J.S.
          &amp; Data Contributors (2013): Review of EUNIS forest habitat classification. Report
          EEA/NSV/13/005. European Environment Agency, Copenhagen.
        </li>
        <b>2012</b>
        <li>
          Schaminée J.H.J., <b>Chytrý M.</b>, Hennekens S.M., Mucina L., Rodwell J.S. &amp; <b>Tichý L.</b>
          (2012): Development of vegetation syntaxa crosswalks to EUNIS habitat classification and
          related data sets. Final report EEA/NSV/12/001. European Environment Agency, Copenhagen.
        </li>
        <b>2011</b>
        <li>
          Dengler J., Jansen F., Glöckler F., Peet R.K., De Cáceres M., <b>Chytrý M.</b>, Ewald J.,
          Oldeland J., Lopez-Gonzalez G., Finckh M., Mucina L., Rodwell J.S., Schaminée J.H.J.
          &amp; Spencer N. (2011): The Global Index of Vegetation-Plot Databases (GIVD): a new
          resource for vegetation science. <i>Journal of Vegetation Science</i> 22: 582–597.
        </li>
        <li>
          Jansen F., Dengler J., Glöckler F., <b>Chytrý M.</b>, Ewald J., Oldeland J. &amp; Schaminée
          J.H.J. (2011): Die mitteleuropäischen Datenbanken im Global Index of Vegetation-Plot
          Databases (GIVD). <i>Tuexenia</i> 31: 351–367.
        </li>
        <li>
          Lengyel A., <b>Chytrý M.</b> &amp; <b>Tichý L.</b> (2011): Heterogeneity-constrained random resampling
          of phytosociological databases. <i>Journal of Vegetation Science</i> 22: 175–183.
        </li>
        <li>
          <b>Tichý L.</b>, <b>Chytrý M.</b> &amp; Šmarda P. (2011): Evaluating the stability of the classification
          of community data. <i>Ecography</i> 34: 807–813.
        </li>
      </div>
    </div>
  )
};

export const project1en = {
  name: "project1",
  title: `European Vegetation Syntheses`,
  body: (
    <div>
      <div>
        <h3>Coordination</h3> Milan Chytrý (chytry@sci.muni.cz)
      </div>
      <br />
      <div>
        <h3>Participants at Masaryk University</h3> Irena Axmanová, Gianmaria Bonari, Jiří
        Danihelka, Jan Divíšek, Pavel Dřevojan, Michal Hájek, Ondřej Hájek, Dana Holubová, Anni
        Jašková, Borja Jiménez-Alfaro, Martin Jiroušek, Veronika Kalníková, Veronika Kalusová, Ilona
        Knollová, Anna Kuzemko, Flavia Landucci, Zdeňka Lososová, Corrado Marcenò, Pavel Novák,
        Josep Padulles Cubino, Tomáš Peterka, Zdenka Preislerová, Marcela Řezníčková, Eva Šmerdová,
        Petra Štěpánková, Jakub Těšitel, Lubomír Tichý, Martin Večeřa, Denys Vynokurov, Viktoria
        Wagner, Dominik Zukal
      </div>
      <br />

      <div>
        <h3>International collaboration</h3> Members of the IAVS Working Group European Vegetation
        Survey
      </div>

      <br />
      <div>
        <h3>Funding</h3>
        <li>
          2019–2023: Czech Science Foundation, EXPRO Centre for European Vegetation Syntheses, grant
          no. 19-28491X
        </li>
		<li>
          2017–2019: Czech Science Foundation, Standard Project Next generation expert systems for
          vegetation classification on a continental scale, grant no. 17-15168S
        </li>
		<li>
          2014–2018: Czech Science Foundation, Centre of Excellence Pladias, grant no. 14-36079G
        </li>
      </div>
      <br />
      <div>
        <h3>Project Aims</h3>
        <div>
          Our group manages the{" "}
          <a href="http://euroveg.org/eva-database"> European Vegetation Archive (EVA)</a>, an
          integrated database of European vegetation plots, which we established in 2012 in
          cooperation with colleagues from the IAVS Working Group European Vegetation Survey. We use
          this resource to analyse different facets of fine-scale diversity of European flora and
          vegetation, and to develop methods and tools for such analyses. Our main focus is on: 
          <li>developing typologies of European habitats as a tool for nature conservation</li>
          <li>
            revising classification system of European vegetation using comprehensive datasets of
            vegetation plots
          </li>
          <li>
            mapping and explaining patterns of fine-scale species richness in European vegetation
          </li>
          <li>
            exploring patterns of phylogenetic and functional diversity in European vegetation
          </li>
          <li>assessing patterns of plant invasions in European vegetation</li>
          <li>developing infrastructure, methods and tools for this research</li>
        </div>
      </div>
      <br />
      <div className="main-results">
        <h3>Main results</h3>
                <p>
          <b>Vegetation databases</b>
		 <div> 
        We established the European Vegetation Archive (EVA; Chytrý et al. 2016) and created several
        thematic databases of European vegetation (e.g. Landucci et al. 2015, Peterka et al. 2015,
        Marcenò &amp; Jiménez-Alfaro 2017, Kalníková &amp; Kudrnovsky 2017, Bonari et al. 2018,
        Jašková et al. 2020). We are also contributing data to sPlot – the global vegetation-plot
        database (Bruelheide et al. 2019).
		  </div>
		</p>
        <p>
          <b>Methods of vegetation analysis and software tools</b>
        <div>
		We developed various methods for statistical analysis of large vegetation-plot databases,
        which are available in the <a href="https://www.sci.muni.cz/botany/juice/">JUICE</a> program by L. Tichý.
        Recently we focused especially on the development of new functions for the expert systems
        for vegetation classification (Landucci et al. 2015, Tichý et al. 2019) and other tools for
        automatic identification of vegetation types (Tichý &amp; Chytrý 2019).
        </div>
		</p>
		<p>
          <b>Classification of European vegetation</b>
        <div>
        We participated in the compilation of the standard list of European vegetation types
        (EuroVegChecklist, Mucina et al. 2016). Using the data from the European Vegetation Archive,
        we participated in several studies based on vegetation plots that provided formalized
        vegetation classification across the whole of Europe or a large part of the continent (e.g.
        Douda et al. 2016, Rodríguez-Rojo et al. 2017, Willner et al. 2017, 2019); some of these
        studies were coordinated by our team (e.g. Peterka et al. 2017, Marcenò et al. 2018, Landucci et al. 2020, Novák et al. 2020).
        </div>
		</p>
		<p>
          <b>European habitat types</b>
        <div>
        We work for the European Environment Agency on the revision and parameterization of the
        EUNIS habitat classification (Schaminée et al. 2012, 2013, 2014, 2016a, 2016b, 2018, 2019, 2020).
        An early version of the revised EUNIS classification was used in the European Red List of
        Habitats (Janssen et al. 2016). We developed a classification expert system for the revised
        habitat types, lists of indicator species and distribution maps, which are essential for the
        application of the EUNIS habitat classification in nature conservation planning, monitoring
        and decision-making in the European Union and beyond.
        </div>
		</p>
		<p>
          <b>Fine-scale diversity of vegetation types</b>
        <div>
        We developed a technique for mapping fine-scale species richness of vegetation types using
        vegetation-plot data (Divíšek &amp; Chytrý 2018), mapped species richness of European
        forests (Večeřa et al. 2019) and modelled species richness of European beech forests
        (Jiménez-Alfaro et al. 2018). We also documented extremely species-rich grasslands in the
        Carpathians and adjacent areas (Chytrý et al. 2015, Roleček et al. 2019).
        </div>
		</p>
		<p>
          <b>Alien plant invasions in European vegetation types</b>
        <div>
        We performed a detailed assessment of alien plant invasions across European forest types
        (Wagner et al. 2017). We also studied alien species pools and exchanges of alien species
        between Europe and other continents in the context of habitat types (Kalusová et al. 2014,
        2015, 2017).
      </div>
	  </p>
	  </div>
      <div className="project-publication">
        <div>
          <h3>Selected research papers</h3>
        </div>
        <b>2020</b>
		<li>
		Giulio S., Acosta A.T.R., Carboni M., Campos J.A., <b>Chytrý M.</b>, Loidi J., Pergl J., Pyšek P., Isermann M., Janssen J.A.M., Rodwell J.S., Schaminée J.H.J. & Marcenò C. (2020): Alien flora across European coastal dunes. <i>Applied Vegetation Science</i> 23: 317–327. – <a href="https://doi.org/10.1111/avsc.12490">https://doi.org/10.1111/avsc.12490</a>
</li>
		  <li>
Küzmič F., Šilc U., <b>Lososová Z.</b>, Mucina L., <b>Chytrý M.</b>, <b>Knollová I.</b>, Hennekens S.M., Berg C., Bergmeier E., Biurrun I., Fanfarillo E., Font X., Iakushenko D., Kovačević Z., Meyer S., Nagy K., Pinke G., Poranen E. & Tereshenko S. (2020): European Weed Vegetation Database – a gap-focused vegetation-plot database. <i>Phytocoenologia</i> 50: 93–100. – <a href="https://doi.org/10.1127/phyto/2019/0337">https://doi.org/10.1127/phyto/2019/0337</a>
         </li>
        <li>
          Gholizadeh H., Naqinezhad A. &amp; <b>Chytrý M.</b> (2020): Classification of the Hyrcanian
          forest vegetation, northern Iran. <i>Applied Vegetation Science</i> 23: 107–126.–
		  <a href="https://doi.org/10.1111/avsc.12469">https://doi.org/10.1111/avsc.12469</a>          
		  </li>
		  <li>
		  <b>Jašková A.</b>, Braslavskaya T.Yu., Tikhonova E., Paal J.,
          Rūsiņa S., Laiviņš M., Kucherov I.B., Genikova N.V., <b>Knollová I.</b>, Chernenkova T.V.,
          Churakova E.Yu., Diekmann M., Halvorsen R., Kirichok E.I., Korotkov V.N., Kryshen A.M.,
          Lugovaya D.L., Morozova O.V., Potapov P.V., Prokazina T.S., Schei F.H., Semenishchenkov
          Yu.A., Shevchenko N.E., Sidorova O.V., Smirnov N.S., Smirnova O.V., Tsvirko R., Turubanova
          S.A. &amp; <b>Chytrý M.</b> (2020): European Boreal Forest Vegetation Database. <i>Phytocoenologia</i> 50: 79–92.
          –
          <a href="https://doi.org/10.1127/phyto/2019/0336">
            https://doi.org/10.1127/phyto/2019/0336
          </a>
        </li>
		<li>
		<b>Landucci F.</b>, Šumberová K., <b>Tichý L.</b>, Hennekens S., Aunina L., Biță‐Nicolae C., Borsukevych L., Bobrov A., Čarni A., De Bie E., Golub V., Hrivnák R., Iemelianova S., Jandt U., Jansen F., Kącki Z., Lájer K., Papastergiadou E., Šilc U., Sinkevičienė Z., Stančić Z., Stepanovič J., Teteryuk B., Tzonev R., Venanzoni R., Zelnik I. & <b>Chytrý M.</b> (2020): Classification of the European marsh vegetation (Phragmito‐Magnocaricetea) to the association level. <i>Applied Vegetation Science</i> 23: 297–316. – <a href="https://doi.org/10.1111/avsc.12484">
            https://doi.org/10.1111/avsc.12484
          </a>
		</li>
		<li>
<b>Novák P.</b>, Willner W., <b>Zukal D.</b>, Kollár J., <b>Roleček J.</b>, Świerkosz K., Ewald J., Wohlgemuth T., Csiky J., Onyshchenko V. & <b>Chytrý M.</b> (2020): Oak-hornbeam forests in central Europe: a formalized classification and syntaxonomic revision. <i>Preslia</i> 92: 1–34. – <a href="https://doi.org/10.23855/preslia.2020.001">
            https://doi.org/10.23855/preslia.2020.001
          </a>
</li>
		<li>
		Schaminée J.H.J., <b>Chytrý M.</b>, Hennekens S.M., Janssen J.A.M., <b>Knollová I.</b>, <b>Lososová Z.</b>, <b>Marcenò C.</b>, <b>Tichý L.</b> & data providers (2020): Updated crosswalks, formal query routines and indicator species of the revised EUNIS Habitat Classification with the European Vegetation Classification for vegetated man-made habitats and aligning of crosswalks between European Red List habitats and Annex I habitats with crosswalks between EUNIS habitats and Annex I habitats. Report EEA/NSS/17/002/Lot 1. European Environment Agency, Copenhagen.
		</li>
        <b>2019</b>
        <li>
          Bonari G., <b>Knollová I.</b>, <b>Vlčková P.</b>, Xystrakis F., Çoban S., Sağlam C., Didukh Y.P.,
          Hennekens S.M., Acosta A.T.R., Angiolini C., Bergmeier E., Bertacchi A., Costa J.C.,
          Fanfarillo E., Gigante D., Guarino R., Landi M., Neto C.S., Pesaresi S., Rosati L., Selvi
          F., Sotiriou A., Stinca A., Turcato C., Tzonev R., Viciani D. &amp; <b>Chytrý M.</b> (2019):{" "}
          CircumMed Pine Forest Database: an electronic archive for Mediterranean and
          Submediterranean pine forest vegetation data. <i>Phytocoenologia</i> 49: 311–318. – 
		  <a href="https://doi.org/10.1127/phyto/2019/0311">https://doi.org/10.1127/phyto/2019/0311</a>
        </li>
        <li>
          Bruelheide H., Dengler J., <b>Jiménez-Alfaro B.</b>, Purschke O., Hennekens S. M., <b>Chytrý M.</b>,
          Pillar V. D., Jansen F., Kattge J., Sandel B., Aubin I., Biurrun I., Field R., Haider S.,
          Jandt U., Lenoir J., Peet R. K., Peyre G., Sabatini F. M., Schmidt M., Schrodt F., Winter
          M., Aćić S., Agrillo E., Alvarez M., Ambarlı D., Angelini P., Apostolova I., Arfin Khan M.
          A., Arnst E., Attorre F., Baraloto C., Beckmann M., Berg C., Bergeron Y., Bergmeier E.,
          Bjorkman A. D., Bondareva V., Borchardt P., Botta‐Dukát Z., Boyle B., Breen A., Brisse H.,
          Byun C., Cabido M. R., Casella L., Cayuela L., Černý T., Chepinoga V., Csiky J., Curran
          M., Ćušterevska R., Dajić Stevanović Z., De Bie E., De Ruffray P., De Sanctis M.,
          Dimopoulos P., Dressler S., Ejrnæs R., El‐Sheikh M. A. E. M., Enquist B., Ewald J.,
          Fagúndez J., Finckh M., Font X., Forey E., Fotiadis G., García‐Mijangos I., de Gasper A.
          L., Golub V., Gutierrez A. G., Hatim M. Z., He T., Higuchi P., <b>Holubová D.</b>, Hölzel N.,
          Homeier J., Indreica A., Isık Gürsoy D., Jansen S., Janssen J., Jedrzejek B., <b>Jiroušek M.</b>,
          Jürgens N., Kącki Z., Kavgacı A., Kearsley E., Kessler M., <b>Knollová I.</b>, Kolomiychuk V.,
          Korolyuk A., Kozhevnikova M., Kozub Ł., Krstonošić D., Kühl H., Kühn I., Kuzemko A.,
          Küzmič F., <b>Landucci F.</b>, Lee M. T., Levesley A., <b>Li C.-F.</b>, Liu H., Lopez‐Gonzalez G.,
          Lysenko T., Macanović A., Mahdavi P., Manning P., <b>Marcenò C.</b>, Martynenko V., Mencuccini
          M., Minden V., Moeslund J. E., Moretti M., Müller J. V., Munzinger J., Niinemets Ü., Nobis
          M., Noroozi J., Nowak A., Onyshchenko V., Overbeck G. E., Ozinga W. A., Pauchard A.,
          Pedashenko H., Peñuelas J., Pérez‐Haase A., <b>Peterka T.</b>, Petřík P., Phillips O. L.,
          Prokhorov V., Rašomavičius V., Revermann R., Rodwell J., Ruprecht E., Rūsiņa S., Samimi
          C., Schaminée J. H. J., Schmiedel U., Šibík J., Šilc U., Škvorc Ž., Smyth A., Sop T.,
          Sopotlieva D., Sparrow B., Stančić Z., Svenning J.-C., Swacha G., Tang Z., Tsiripidis I.,
          Turtureanu P. D., Ugurlu E., Uogintas D., Valachovič M., Vanselow K. A., Vashenyak Y.,
          Vassilev K., Vélez‐Martin E., Venanzoni R., Vibrans A. C., Violle C., Virtanen R., von
          Wehrden H., Wagner V., Walker D. A., Wana D., Weiher E., Wesche K., Whitfeld T., Willner
          W., Wiser S., Wohlgemuth T., Yamalov S., Zizka G. &amp; Zverev A. (2019): sPlot – a new tool
          for global vegetation analyses. <i>Journal of Vegetation Science</i> 30: 161–186. – {" "}
		  <a href="https://doi.org/10.1111/jvs.12710">https://doi.org/10.1111/jvs.12710</a>
          
        </li>
        <li>
          <b>Chytrý K.</b>, <b>Novák P.</b>, <b>Kalníková V.</b>, <b>Večeřa M.</b>, <b>Prokešová H.</b>, <b>Dřevojan P.</b> &amp; <b>Chytrý M.</b>
          (2019): Dry grassland vegetation in the Transcarpathian Lowland (western Ukraine).
          <i> Tuexenia</i> 39: 335–355. – {" "}
		  <a href="https://doi.org/10.14471/2019.39.009">https://doi.org/10.14471/2019.39.009</a> 
        </li>
        <li>
          Gholizadeh H., Naqinezhad A. &amp; <b>Chytrý M.</b> (2019): Hyrcanian Forest Vegetation Database.
          <i> Phytocoenologia</i> 49: 209–210. – {" "}
		  <a href="https://doi.org/10.1127/phyto/2018/0315">https://doi.org/10.1127/phyto/2018/0315</a> 
        </li>
        <li>
          Mastrogianni A., Kallimanis A.S., <b>Chytrý M.</b> &amp; Tsiripidis I. (2019): Phylogenetic
          diversity patterns in forests of a putative refugial area in Greece: A community level
          analysis. <i>Forest Ecology and Management</i> 446: 226–237. – {" "}
		  <a href="https://doi.org/10.1016/j.foreco.2019.05.044">https://doi.org/10.1016/j.foreco.2019.05.044</a>
          
        </li>
        <li>
          <b>Novák P.</b>, <b>Zukal D.</b>, <b>Kalníková V.</b>, <b>Chytrý K.</b>, &amp; Kavgacı A. (2019): Ecology and
          syntaxonomy of Colchic forests in south-western Georgia (Caucasus region). <i>Phytocoenologia </i>
          49: 231–248. – {" "}
		  <a href="https://doi.org/10.1127/phyto/2019/0250">https://doi.org/10.1127/phyto/2019/0250</a>
        </li>
        <li>
          Pätsch R., <b>Jašková A.</b>, <b>Chytrý M.</b>, Kucherov I.B., Schaminée J.H.J., Bergmeier E. &amp;
          Janssen J.A.M. (2019): Making them visible and usable – vegetation‐plot observations from
          Fennoscandia based on historical species‐quantity scales. <i>Applied Vegetation Science</i> 22: {" "}
          465–473. – {" "}
		  <a href="https://doi.org/10.1111/avsc.12452">https://doi.org/10.1111/avsc.12452</a>
        </li>
        <li>
          <b>Roleček J.</b>, <b>Hájek M.</b>, <b>Dřevojan P.</b>, <b>Prokešová H.</b>, Fajmon K., <b>Těšitel J.</b>, <b>Daněk P.</b>, <b>Hájková
          P.</b>, Jongepierová I., <b>Novák P.</b>, Poluyanov A. V., Shumska N. V., &amp; Chorney I. I. (2019): {" "}
          Gradients, species richness and biogeographical links of steppe grasslands in Western
          Podolia (Ukraine). <i>Phytocoenologia</i> 49: 349–367. – {" "}
		  <a href="https://doi.org/10.1127/phyto/2019/0255">https://doi.org/10.1127/phyto/2019/0255</a>
        </li>
		<li>
		  Schaminée J.H.J., <b>Chytrý M.</b>, <b>Hájek M.</b>, Hennekens S.M., Janssen J.A.M., <b>Jiroušek M.</b>, <b>Knollová I.</b>, <b>Marcenò C.</b>, <b>Peterka T.</b>, Rodwell J.S., <b>Tichý L.</b> & data providers (2019): Updated crosswalks of the revised EUNIS Habitat Classification with the European Vegetation Classification and the European Red List Habitats for EUNIS coastal habitats and wetlands. Formal query routines and indicator species. Report EEA/NSS/17/002/Lot 1. European Environment Agency, Copenhagen.
		  </li>
        <li>
          Sporbert M., Bruelheide H., Seidler G., Keil P., Jandt U., Austrheim G., Biurrun I.,
          Campos J. A., Čarni A., <b>Chytrý M.</b>, Csiky J., Bie E. D., Dengler J., Golub V., Grytnes
          J.-A., Indreica A., Jansen F., <b>Jiroušek M.</b>, Lenoir J., Luoto M., <b>Marcenò C.</b>, Moeslund J.
          E., Pérez‐Haase A., Rūsiņa S., Vandvik V., Vassilev K. &amp; Welk E. (2019): Assessing
          sampling coverage of species distribution in biodiversity databases. <i>Journal of Vegetation
          Science</i> 30: 620–632. – {" "}
		  <a href="https://doi.org/10.1111/jvs.12763">https://doi.org/10.1111/jvs.12763</a> 
        </li>
        <li>
          <b>Tichý L.</b> &amp; <b>Chytrý M.</b> (2019): Probabilistic key for identifying vegetation types in the
          field: a new method and Android application. <i>Journal of Vegetation Science</i> 30: 1035–1038.
          – <a href="https://doi.org/10.1111/jvs.12799">https://doi.org/10.1111/jvs.12799</a> 
        </li>
        <li>
          <b>Tichý L.</b>, <b>Chytrý M.</b> &amp; <b>Landucci F.</b> (2019): GRIMP: A machine-learning method for
          improving groups of discriminating species in expert systems for vegetation
          classification. <i>Journal of Vegetation Science</i> 30: 5–17. – {" "}
		  <a href="https://doi.org/10.1111/jvs.12696">https://doi.org/10.1111/jvs.12696</a>
          
        </li>
        <li>
          <b>Večeřa M.</b>, <b>Divíšek J.</b>, Lenoir J., <b>Jiménez-Alfaro B.</b>, Biurrun I., <b>Knollová I.</b>, Agrillo E.,
          Campos J.A., Čarni A., Crespo Jiménez G., Ćuk M., Dimopoulos P., Ewald J.,
          Fernández-González F., Gégout J.-C., Indreica A., Jandt U., Jansen F., Kącki Z.,
          Rašomavičius V., <b>Řezníčková M.</b>, Rodwell J.S., Schaminée J.H.J., Šilc U., Svenning
          J.-C., Swacha G., Vassilev K., Venanzoni R., Willner W., Wohlgemuth T. &amp; <b>Chytrý M. </b>
          (2019): Alpha diversity of vascular plants in European forests. <i>Journal of Biogeography</i>
          46: 1919–1935. – {" "}
		  <a href="https://doi.org/10.1111/jbi.13624">https://doi.org/10.1111/jbi.13624</a> 
        </li>
        <li>
          Willner W., <b>Roleček J.</b>, Korolyuk A., Dengler J., <b>Chytrý M.</b>, Janišová M., Lengyel A., Aćić
          S., Becker T., Ćuk M., Demina O., Jandt U., Kącki Z., Kuzemko A., Kropf M., Lebedeva M.,
          Semenishchenkov Y., Šilc U., Stančić Z., Staudinger M., Vassilev K. &amp; Yamalov S.
          (2019): Formalized classification of semi-dry grasslands in central and eastern Europe.
          <i> Preslia</i> 91: 25–49. – {" "}
		  <a href="https://doi.org/10.23855/preslia.2019.025">https://doi.org/10.23855/preslia.2019.025</a> 
        </li>
        <b>2018</b>
        <li>
          Bruelheide H., Dengler J., Purschke O., Lenoir J., <b>Jiménez-Alfaro B.</b>, Hennekens S.M.,
          Botta-Dukát Z., <b>Chytrý M.</b>, Field R., Jansen F., Kattge J., Pillar V.D., Schrodt F.,
          Mahecha M.D., Peet R.K., Sandel B., van Bodegom P., Altman J., Alvarez-Dávila E., Arfin
          Khan M.A.S., Attorre F., Aubin I., Baraloto C., Barroso J.G., Bauters M., Bergmeier E.,
          Biurrun I., Bjorkman A.D., Blonder B., Čarni A., Cayuela L., Černý T., Cornelissen J.H.C.,
          Craven D., Dainese M., Derroire G., De Sanctis M., Díaz S., Doležal J., Farfan-Rios W.,
          Feldpausch T.R., Fenton N.J., Garnier E., Guerin G.R., Gutiérrez A.G., Haider S., Hattab
          T., Henry G., Hérault B., Higuchi P., Hölzel N., Homeier J., Jentsch A., Jürgens N., Kącki
          Z., Karger D.N., Kessler M., Kleyer M., <b>Knollová I.</b>, Korolyuk A.Y., Kühn I., Laughlin
          D.C., Lens F., Loos J., Louault F., Lyubenova M.I., Malhi Y., <b>Marcenò C.</b>, Mencuccini M.,
          Müller J.V., Munzinger J., Myers-Smith I.H., Neill D.A., Niinemets Ü., Orwin K.H., Ozinga
          W.A., Penuelas J., Pérez-Haase A., Petřík P., Phillips O.L., Pärtel M., Reich P.B.,
          Römermann C., Rodrigues A.V., Sabatini F.M., Sardans J., Schmidt M., Seidler G., Silva
          Espejo J.E., Silveira M., Smyth A., Sporbert M., Svenning J.-C., Tang Z., Thomas R.,
          Tsiripidis I., Vassilev K., Violle C., Virtanen R., Weiher E., Welk E., Wesche K., Winter
          M., Wirth C. &amp; Jandt U. (2018): Global trait–environment relationships of plant
          communities. <i><i>Nature Ecology &amp; Evolution</i></i> 2: 1906–1917. – {" "}
		  <a href="https://www.nature.com/articles/s41559-018-0699-8">https://www.nature.com/articles/s41559-018-0699-8</a>
          
        </li>
        <li>
          Del Vecchio S., Fantinato E., Janssen J. A. M., Bioret F., Acosta A., Prisco I., Tzonev
          R.,<b> <b>Marcenò C.</b></b>, Rodwell J. &amp; Buffa G. (2018): Biogeographic variability of coastal
          perennial grasslands at the European scale. <i>Applied Vegetation Science</i> 21: 312–321. – {" "}
		  <a href="https://doi.org/10.1111/avsc.12356">https://doi.org/10.1111/avsc.12356</a>
        </li>
        <li>
          <b>Divíšek J.</b> &amp; <b>Chytrý M.</b> (2018): High-resolution and large-extent mapping of plant
          species richness using vegetation-plot databases. <i>Ecological Indicators</i> 89: 840–851. – {" "}
		  <a href="https://doi.org/10.1016/j.ecolind.2017.11.005">https://doi.org/10.1016/j.ecolind.2017.11.005</a>
          
        </li>
        <li>
          <b>Jiménez-Alfaro B.</b>, Girardello M., <b>Chytrý M.</b>, Svenning J.-C., Willner W., Gégout J.-C.,
          Agrillo E., Campos J.A., Jandt U., Kącki Z., Šilc U., Slezák M., <b>Tichý L.</b>, Tsiripidis I.,
          Turtureanu P.D., Ujházyová M. &amp; Wohlgemuth T. (2018): History and environment shape
          species pools and community diversity in European beech forests. <i>Nature Ecology &amp;
          Evolution</i> 2: 483–490. – {" "}
		  <a href="http://dx.doi.org/10.1038/s41559-017-0462-6">http://dx.doi.org/10.1038/s41559-017-0462-6</a> 
        </li>
        <li>
          <b>Jiménez-Alfaro B.</b>, Suárez-Seoane S., <b>Chytrý M.</b>, Hennekens S.M., Willner W., <b>Hájek M.</b>,
          Agrillo E., Álvarez-Martínez J.M., Bergamini A., Brisse H., Brunet J., Casella L., Dítě
          D., Font X., Gillet F., <b>Hájková P.</b>, Jansen F., Jandt U., Kącki Z., Lenoir J., Rodwell
          J.S., Schaminée J.H.J., <b>Sekulová L.</b>, Šibík J., Škvorc Ž. &amp; Tsiripidis I. (2018): {" "}
          Modelling the distribution and compositional variation of plant communities at the
          continental scale. <i>Diversity and Distributions</i> 24: 978–990. – {" "}
		  <a href="https://doi.org/10.1111/ddi.12736">https://doi.org/10.1111/ddi.12736</a>
          
        </li>
        <li>
          <b>Marcenò C.</b>, Guarino R., Loidi J., Herrera M., Isermann M., <b>Knollová I.</b>, <b>Tichý L.</b>, Tzonev
          R.T., Acosta A.T.R., FitzPatrick Ú., Iakushenko D., Janssen J.A.M., <b>Jiménez-Alfaro B.</b>,
          Kącki Z., Keizer-Sedláková I., Kolomiychuk V., Rodwell J.S., Schaminée J.H.J., Šilc U.
          &amp; <b>Chytrý M.</b> (2018): Classification of European and Mediterranean coastal dune
          vegetation. <i>Applied Vegetation Science</i> 21: 533–559. – {" "}
		  <a href="https://doi.org/10.1111/avsc.12379">https://doi.org/10.1111/avsc.12379</a>
        </li>
        <li>
          Roces-Díaz J.V., <b>Jiménez-Alfaro B.</b>, <b>Chytrý M.</b>, Díaz-Varela E.R. &amp; Álvarez-Álvarez P.
          (2018): Glacial refugia and mid-Holocene expansion delineate the current distribution of
          Castanea sativa in Europe. <i>Palaeogeography, Palaeoclimatology, Palaeoecology</i> 491: 152–160. –{" "}
		  <a href="https://doi.org/10.1016/j.palaeo.2017.12.004">https://doi.org/10.1016/j.palaeo.2017.12.004</a> 
        </li>
        <li>
          Sabatini F.M., <b>Jiménez-Alfaro B.</b>, Burrascano S., Lora A. &amp; <b>Chytrý M.</b> (2018): {" "}
          Beta-diversity of Central European forests decreases along an elevational gradient due to
          the variation in local community assembly processes. <i>Ecography</i> 41: 1038–1048. – {" "}
		  <a href="http://dx.doi.org/10.1111/ecog.02809">http://dx.doi.org/10.1111/ecog.02809</a>
          
        </li>
        <li>
          Schaminée J.H.J., <b>Chytrý M.</b>, Hennekens S.M., Janssen J.A.M., <b>Knollová I.</b>, Rodwell J.S.,
          <b> Tichý L.</b> &amp; data providers (2018): Updated crosswalk of the revised EUNIS Habitat
          Classification with the European vegetation classification and indicator species for the
          EUNIS grassland, shrubland and forest types. Report EEA/NSS/17/002/Lot 1. European
          Environment Agency, Copenhagen.
        </li>
        <b>2017</b>
        <li>
          <b>Kalníková V.</b> &amp; Kudrnovsky H. (2017): Gravel Bar Vegetation Database. <i>Phytocoenologia </i>
          47: 109–110. – {" "}
		  <a href="https://doi.org/10.1127/phyto/2017/0177
">https://doi.org/10.1127/phyto/2017/0177
</a>
        </li>
        <li>
          <b><b>Kalusová V.</b></b>, <b>Chytrý M.</b>, van Kleunen M., Mucina L., Dawson W., Essl F., Kreft H., Pergl J.,
          Weigelt P., Winter M. &amp; Pyšek P. (2017): Naturalization of European plants on other
          continents: The role of donor habitats. <i>Proceedings of the National Academy of Sciences of
          the USA</i> 114: 13756–13761. – {" "}
		  <a href="http://dx.doi.org/10.1073/pnas.1705487114">http://dx.doi.org/10.1073/pnas.1705487114</a> 
        </li>
        <li>
          <b><b>Marcenò C.</b></b> &amp; <b>Jiménez-Alfaro B.</b> (2017): The Mediterranean Ammophiletea Database: a
          comprehensive dataset of coastal dune vegetation. <i>Phytocoenologia</i> 47: 95–105. – {" "}
		  <a href="http://doi.org/10.1127/phyto/2016/0133
">http://doi.org/10.1127/phyto/2016/0133
</a>
        </li>
        <li>
          <b>Novák P.</b>, <b>Zukal D.</b>, <b>Večeřa M.</b> &amp; <b>Píšťková K.</b> (2017): Vegetation of oak-hornbeam, scree
          and ravine forests at lower altitudes in Transcarpathia, Western Ukraine. <i>Tuexenia</i> 37: {" "}
          47–63. – {" "}
		  <a href="http://doi.org/10.14471/2017.37.021
">http://doi.org/10.14471/2017.37.021
</a>
        </li>
        <li>
          <b>Peterka T.</b>, <b>Hájek M.</b>, <b>Jiroušek M.</b>, <b>Jiménez-Alfaro B.</b>, Aunina L., Bergamini A., Dítě D.,
          Felbaba- Klushyna L., Graf U., <b>Hájková P.</b>, <b>Hettenbergerová E.</b>, Ivchenko T.G., Jansen F.,
          Koroleva N.E., Lapshina E.D., Lazarević P.M., Moen A., Napreenko M.G., Pawlikowski P.,
          <b> Plesková Z.</b>, <b>Sekulová L.</b>, Smagin V.A., Tahvanainen T., Thiele A., Biţă-Nicolae C., Biurrun
          I., Brisse H., Ćušterevska R., De Bie E., Ewald J., FitzPatrick Ú., Font X., Jandt U.,
          Kącki Z., Kuzemko A., <b>Landucci F.</b>, Moeslund J.E., Pérez-Haase A., Rašomavičius V., Rodwell
          J.S., Schaminée J.H.J., Šilc U., Stančić Z. &amp; <b>Chytrý M.</b> (2017): Formalized
          classification of European fen vegetation at the alliance level. <i>Applied Vegetation
          Science</i> 20: 124–142. – {" "}
		  <a href="http://dx.doi.org/10.1111/avsc.12271">http://dx.doi.org/10.1111/avsc.12271</a> 
        </li>
        <li>
          Rodríguez-Rojo M.P., <b>Jiménez-Alfaro B.</b>, Jandt U., Bruelheide H., Rodwell J.S., Schaminée
          J.H.J., Perrin P.M., Kącki Z., Willner W., Fernández-González F. &amp; <b>Chytrý M.</b> (2017): {" "}
          Diversity of lowland hay meadows and pastures in Western and Central Europe. <i>Applied
          Vegetation Science</i> 20: 702–719. – {" "}
		  <a href="http://dx.doi.org/10.1111/avsc.12326">http://dx.doi.org/10.1111/avsc.12326</a> 
        </li>
        <li>
          Wagner V., <b>Chytrý M.</b>, <b>Jiménez-Alfaro B.</b>, Pergl J., Hennekens S., Biurrun I., <b>Knollová I.</b>,
          Berg C., Vassilev K., Rodwell J.S., Škvorc Ž., Jandt U., Ewald J., Jansen F., Tsiripidis
          I., Botta-Dukát Z., Casella L., Attorre F., Rašomavičius V., Ćušterevska R., Schaminée
          J.H.J., Brunet J., Lenoir J., Svenning J.-C., Kącki Z., Petrášová-Šibíková M., Šilc U.,
          García-Mijangos I., Campos J.A., Fernández-González F., Wohlgemuth T., Onyshchenko V.
          &amp; Pyšek P. (2017): Alien plant invasions in European woodlands. <i>Diversity and
          Distributions</i> 23: 969–981. –{" "}
		  <a href="http://dx.doi.org/10.1111/ddi.12592">http://dx.doi.org/10.1111/ddi.12592</a> 
        </li>
        <li>
          Willner W., <b>Jiménez-Alfaro B.</b>, Agrillo E., Biurrun I., Campos J.A., Čarni A., Casella L.,
          Csiky J., Ćušterevska R., Didukh Ya.P., Ewald J., Jandt U., Jansen F., Kącki Z., Kavgacı
          A., Lenoir J., Marinšek A., Onyshchenko V., Rodwell J., Schaminée J., Šibík J., Škvorc Ž.,
          Svenning J.-C., Tsiripidis J., Turtureanu P.D., Tzonev R., Vassilev K., Venanzoni R.,
          Wohlgemuth T. &amp; <b>Chytrý M.</b> (2017): Classification of European beech forests: a Gordian
          Knot? <i>Applied Vegetation Science</i> 20: 494–512. – {" "}
		  <a href="http://dx.doi.org/10.1111/avsc.12299">http://dx.doi.org/10.1111/avsc.12299</a>
        </li>
        <li>
          Willner W., Kuzemko A., Dengler J., <b>Chytrý M.</b>, Bauer N., Becker T., Biţă-Nicolae C.,
          Botta-Dukát Z., Čarni A., Csiky J., Igić R., Kącki Z., Korotchenko I., Kropf M.,
          Krstivojević-Ćuk M., Krstonošić D., Rédei T., Ruprecht E., Schratt-Ehrendorfer L.,
          Semenishchenkov Y., Stančić Z., Vashenyak Y., Vynokurov D. &amp; Janišová M. (2017): A
          higher-level classification of the Pannonian and western Pontic steppe grasslands (Central
          and Eastern Europe). <i>Applied Vegetation Science</i> 20: 143–158. –{" "}
		  <a href="http://dx.doi.org/10.1111/avsc.12265">http://dx.doi.org/10.1111/avsc.12265</a>
          
        </li>
        <b>2016</b>
        <li>
          <b>Chytrý M.</b>, Hennekens S.M., <b>Jiménez-Alfaro B.</b>, <b>Knollová I.</b>, Dengler J., Jansen F., <b>Landucci
          F.</b>, Schaminée J.H.J., Aćić S., Agrillo E., Ambarlı D., Angelini P., Apostolova I., Attorre
          F., Berg C., Bergmeier E., Biurrun I., Botta-Dukát Z., Brisse H., Campos J.A., Carlón L.,
          Čarni A., Casella L., Csiky J., Ćušterevska R., Dajić Stevanović Z., <b>Danihelka J.</b>, De Bie
          E., de Ruffray P., De Sanctis M., Dickoré W.B., Dimopoulos P., Dubyna D., Dziuba T.,
          Ejrnæs R., Ermakov N., Ewald J., Fanelli G., Fernández-González F., FitzPatrick Ú., Font
          X., García-Mijangos I., Gavilán R.G., Golub V., Guarino R., Haveman R., Indreica A., Işık
          Gürsoy D., Jandt U., Janssen J.A.M., <b>Jiroušek M.</b>, Kącki Z., Kavgacı A., Kleikamp M.,
          Kolomiychuk V., Krstivojević Ćuk M., Krstonošić D., Kuzemko A., Lenoir J., Lysenko T.,
          <b> Marcenò C.</b>, Martynenko V., <b>Michalcová D.</b>, Moeslund J.E., Onyshchenko V., Pedashenko H.,
          Pérez-Haase A., <b>Peterka T.</b>, Prokhorov V., Rašomavičius V., Rodríguez-Rojo M.P., Rodwell
          J.S., Rogova T., Ruprecht E., Rūsiņa S., Seidler G., Šibík J., Šilc U., Škvorc Ž.,
          Sopotlieva D., Stančić Z., Svenning J.-C., Swacha G., Tsiripidis I., Turtureanu P.D.,
          Uğurlu E., Uogintas D., Valachovič M., Vashenyak Y., Vassilev K., Venanzoni R., Virtanen
          R., Weekes L., Willner W., Wohlgemuth T. &amp; Yamalov S. (2016): European Vegetation
          Archive (EVA): an integrated database of European vegetation plots. <i>Applied Vegetation
          Science</i> 19: 173–180. – {" "}
		  <a href="https://doi.org/10.1111/avsc.12191
">https://doi.org/10.1111/avsc.12191
</a>
        </li>
        <li>
          Douda J., Boublík K., Slezák M., Biurrun I., Nociar J., Havrdová A., Doudová J., Aćić S.,
          Brisse H., Brunet J., <b>Chytrý M.</b>, Claessens H., Csiky J., Didukh Ya., Dimopoulos P.,
          Dullinger S., FitzPatrick Ú., Guisan A., Horchler P.J., Hrivnák R., Jandt U., Kącki Z.,
          Kevey B., <b>Landucci F.</b>, Lecomte H., Lenoir J., Paal J., Paternoster D., Pauli H., Pielech
          R., Rodwell J.S., Roelandt B., Svenning J.-C., Šibík J., Šilc U., Škvorc Ž., Tsiripidis
          I., Tzonev R.T., Wohlgemuth T. &amp; Zimmermann N.E. (2016): Vegetation classification and
          biogeography of European floodplain forests and alder carrs. <i>Applied Vegetation Science </i>
          19: 147–163.
        </li>
        <li>
          Janssen J.A.M., Rodwell J.S., García Criado M., Gubbay S., Haynes T., Nieto A., Sanders
          N., <b>Landucci F.</b>, Loidi J., Ssymank A., Tahvanainen T., Valderrabano M., Acosta A.,
          Aronsson M., Arts G., Attorre F., Bergmeier E., Bijlsma R.-J., Bioret F., Biţă-Nicolae C.,
          Biurrun I., Calix M., Capelo J., Čarni A., <b>Chytrý M.</b>, Dengler J., Dimopoulos P., Essl F.,
          Gardfjell H., Gigante D., Giusso del Galdo G., <b>Hájek M.</b>, Jansen F., Jansen J., Kapfer J.,
          Mickolajczak A., Molina J.A., Molnár Z., Paternoster D., Piernik A., Poulin B., Renaux B.,
          Schaminée J.H.J., Šumberová K., Toivonen H., Tonteri T., Tsiripidis I., Tzonev R. &amp;
          Valachovič M. (2016): European Red List of Habitats - Part 2. Terrestrial and freshwater
          habitats. Publications Office of the European Union, Luxembourg.
        </li>
        <li>
          Mucina L., Bültmann H., Dierßen K., Theurillat J.-P., Raus T., Čarni A., Šumberová K.,
          Willner W., Dengler J., Gavilán García R., <b>Chytrý M.</b>, <b>Hájek M.</b>, Di Pietro R., Iakushenko
          D., Pallas J., Daniëls F.J.A., Bergmeier E., Santos Guerra A., Ermakov N., Valachovič M.,
          Schaminée J.H.J., Lysenko T., Didukh Ya.P., Pignatti S., Rodwell J.S., Capelo J., Weber
          H.E., Solomeshch A., Dimopoulos P., Aguiar C., Hennekens S.M. &amp; <b>Tichý L.</b> (2016): {" "}
          Vegetation of Europe: Hierarchical floristic classification system of vascular plant,
          bryophyte, lichen, and algal communities. <i>Applied Vegetation Science</i> 19, Suppl. 1: 3–264.
        </li>
        <li>
          Schaminée J.H.J., <b>Chytrý M.</b>, Hennekens S.M., Janssen J.A.M., <b>Jiménez-Alfaro B.</b>, <b>Knollová
          I.</b>, <b>Marceno C.</b>, Mucina L., Rodwell J.S., <b>Tichý L.</b> &amp; data-providers (2016a): Review of
          grassland habitats and development of distribution maps of heathland, scrub and tundra
          habitats of EUNIS habitats classification. Report EEA/NSV/15/005. European Environment
          Agency, Copenhagen.
        </li>
        <li>
          Schaminée J.H.J., <b>Chytrý M.</b>, Dengler J., Hennekens S.M., Janssen J.A.M., <b>Jiménez-Alfaro
          B.</b>, <b>Knollová I.</b>, <b>Landucci F.</b>, <b>Marcenò C.</b>, Rodwell J.S., <b>Tichý L.</b> &amp; data-providers
          (2016b): Development of distribution maps of grassland habitats of EUNIS habitat
          classification. Report EEA/NSV/16/005. European Environment Agency, Copenhagen.
        </li>
        <li>
          Ujházyová M., Ujházy K., <b>Chytrý M.</b>, Willner W., Čiliak M., Máliš F. &amp; Slezák M.
          (2016): Diversity of beech forest vegetation in the Eastern Alps, Bohemian Massif and the
          Western Carpathians. <i>Preslia</i> 88: 435–457.
        </li>
        <b>2015</b>
        <li>
          <b>Chytrý M.</b>, Dražil T., <b>Hájek M.</b>, <b>Kalníková V.</b>, <b>Preislerová Z.</b>, Šibík J., Ujházy K.,
          <b> Axmanová I.</b>, Bernátová D., Blanár D., Dančák M., <b>Dřevojan P.</b>, Fajmon K., Galvánek D.,
          <b> Hájková P.</b>, Herben T., Hrivnák R., Janeček Š., Janišová M., Jiráská Š., Kliment J.,
          Kochjarová J., Lepš J., Leskovjanská A., <b>Merunková K.</b>, Mládek J., Slezák M., Šeffer J.,
          Šefferová V., Škodová I., Uhlířová J., Ujházyová M. &amp; <b>Vymazalová M.</b> (2015): The most
          species-rich plant communities in the Czech Republic and Slovakia (with new world
          records). <i>Preslia</i> 87: 217–278. – {" "}
		  <a href="http://www.preslia.cz/2015.html#chytry
">PDF
</a>
        </li>
        <li>
          De Cáceres M., <b>Chytrý M.</b>, Agrillo E., Attorre F., Botta-Dukát Z., Capelo J., Czúcz B.,
          Dengler J., Ewald J., Faber-Langendoen D., Feoli E., Franklin S.B., Gavilán R., Gillet F.,
          Jansen F., <b>Jiménez-Alfaro B.</b>, Krestov P., <b>Landucci F.</b>, Lengyel A., Loidi J., Mucina L.,
          Peet R.K., Roberts D.W., <b>Roleček J.</b>, Schaminée J.H.J., Schmidtlein S., Theurillat J.-P.,
          <b> Tichý L.</b>, Walker D.A., Wildi O., Willner W. &amp; Wiser S.K. (2015): A comparative
          framework for broad-scale plot-based vegetation classification. <i>Applied Vegetation Science </i>
          18: 543–560.
        </li>
        <li>
          <b>Jiménez-Alfaro B.</b>, <b>Marcenò C.</b>, Guarino R. &amp; <b>Chytrý M.</b> (2015): Regional metacommunities
          in two coastal systems: spatial structure and drivers of plant assemblages. <i>Journal of
          Biogeography</i> 42: 452–462.
        </li>
        <li>
          <b><b>Kalusová V.</b></b>, <b>Chytrý M.</b>, Peet R.K. &amp; Wentworth T.R. (2015): Intercontinental comparison
          of habitat levels of invasion between temperate North America and Europe. <i>Ecology</i> 96: {" "}
          3363–3373.
        </li>
        <li>
          <b>Landucci F.</b>, <b>Řezníčková M.</b>, Šumberová K., <b>Chytrý M.</b>, Aunina L., Biţă-Nicolae C., Bobrov
          A., Borsukevych L., Brisse H., Čarni A., Csiky J., Cvijanović D., De Bie E., De Ruffray
          P., Dubyna D., Dimopoulos P., Dziuba T., FitzPatrick Ú., Font X., Gigante D., Golub V.,
          Hennekens S.M., Hrivnák R., Iemelianova S., Jandt U., Jenačković D., Jansen F., Kącki Z.,
          Lájer K., Matulevičiutė D., Mesterházy A., <b>Michalcová D.</b>, Paal J., Papastergiadou E.,
          Properzi A., Radulović S., Rodwell J.S., Schaminée J.H.J., Šilc U., Sinkevičienė Z.,
          Stančić Z., Stepanovich J., Teteryuk B., Tzonev R., Venanzoni R., Weekes L. &amp; Willner
          W. (2015): WetVegEurope: a database of aquatic and wetland vegetation of Europe.
          <i> Phytocoenologia</i> 45: 187–194.
        </li>
        <li>
          <b>Landucci F.</b>, <b>Tichý L.</b>, Šumberová K. &amp; <b>Chytrý M.</b> (2015): Formalized classification of
          species-poor vegetation: a proposal of a consistent protocol for aquatic vegetation.
          <i> Journal of Vegetation Science</i> 26: 791–803.
        </li>
        <li>
          <b>Palpurina S.</b>, <b>Chytrý M.</b>, Tzonev R., <b>Danihelka J.</b>, <b>Axmanová I.</b>, <b>Merunková K.</b>, <b>Duchoň M. </b>
          &amp; Karakiev T. (2015): Patterns of fine-scale plant species richness in dry grasslands
          across the eastern Balkan Peninsula. <i>Acta Oecologica</i> 63: 36–46.
        </li>
        <li>
          <b>Peterka T.</b>, <b>Jiroušek M.</b>, <b>Hájek M.</b> &amp; <b>Jiménez-Alfaro B.</b> (2015): European Mire Vegetation
          Database: a gap-oriented database for European fens and bogs. <i>Phytocoenologia</i> 45: 291–298.
        </li>
        <b>2014</b>
        <li>
          <b>Jiménez-Alfaro B.</b>, <b>Chytrý M.</b>, Rejmánek M. &amp; Mucina L. (2014): The number of vegetation
          types in European countries: major determinants and extrapolation to other regions.
          <i> Journal of Vegetation Science</i> 25: 863–872.
        </li>
        <li>
          <b><b>Kalusová V.</b></b>, <b>Chytrý M.</b>, Peet R.K. &amp; Wentworth T.R. (2014): Alien species pool
          influences the level of habitat invasion in intercontinental exchange of alien plants.
          <i> Global Ecology and Biogeography</i> 23: 1366–1375.
        </li>
        <li>
          Rodríguez-Rojo M.P., Fernández-González F., <b>Tichý L.</b> &amp; <b>Chytrý M.</b> (2014): Vegetation
          diversity of mesic grasslands (Arrhenatheretalia) in the Iberian Peninsula. <i>Applied
          Vegetation Science</i> 17: 780–796.
        </li>
        <li>
          Schaminée J.H.J., <b>Chytrý M.</b>, Hennekens S.M., Janssen J.A.M., <b>Jiménez-Alfaro B.</b>, <b>Knollová
          I.</b>, Mucina L., Rodwell J.S., <b>Tichý L.</b> &amp; data-providers (2014): Vegetation analysis and
          distribution maps for EUNIS habitats. Report EEA/NSV/14/006. European Environment Agency,
          Copenhagen.
        </li>
        <li>
          <b>Tichý L.</b>, <b>Chytrý M.</b> &amp; Botta-Dukát Z. (2014): Semi-supervised classification of
          vegetation: preserving the good old units and searching for new ones. <i>Journal of
          Vegetation Science</i> 25: 1504–1512.
        </li>
        <b>2013</b>
        <li>
          <b>Landucci F.</b>, Venanzoni R., Gigante D. &amp; <b>Chytrý M.</b> (2013): Wetland vegetation of the
          class Phragmito- Magno-Caricetea in central Italy. <i>Phytocoenologia</i> 43: 67–100.
        </li>
        <li>
          Schaminée J.H.J., <b>Chytrý M.</b>, Hennekens S.M., <b>Jiménez-Alfaro B.</b>, Mucina L., Rodwell J.S.
          &amp; Data Contributors (2013): Review of EUNIS forest habitat classification. Report
          EEA/NSV/13/005. European Environment Agency, Copenhagen.
        </li>
        <b>2012</b>
        <li>
          Schaminée J.H.J., <b>Chytrý M.</b>, Hennekens S.M., Mucina L., Rodwell J.S. &amp; <b>Tichý L.</b>
          (2012): Development of vegetation syntaxa crosswalks to EUNIS habitat classification and
          related data sets. Final report EEA/NSV/12/001. European Environment Agency, Copenhagen.
        </li>
        <b>2011</b>
        <li>
          Dengler J., Jansen F., Glöckler F., Peet R.K., De Cáceres M., <b>Chytrý M.</b>, Ewald J.,
          Oldeland J., Lopez-Gonzalez G., Finckh M., Mucina L., Rodwell J.S., Schaminée J.H.J.
          &amp; Spencer N. (2011): The Global Index of Vegetation-Plot Databases (GIVD): a new
          resource for vegetation science. <i>Journal of Vegetation Science</i> 22: 582–597.
        </li>
        <li>
          Jansen F., Dengler J., Glöckler F., <b>Chytrý M.</b>, Ewald J., Oldeland J. &amp; Schaminée
          J.H.J. (2011): Die mitteleuropäischen Datenbanken im Global Index of Vegetation-Plot
          Databases (GIVD). <i>Tuexenia</i> 31: 351–367.
        </li>
        <li>
          Lengyel A., <b>Chytrý M.</b> &amp; <b>Tichý L.</b> (2011): Heterogeneity-constrained random resampling
          of phytosociological databases. <i>Journal of Vegetation Science</i> 22: 175–183.
        </li>
        <li>
          <b>Tichý L.</b>, <b>Chytrý M.</b> &amp; Šmarda P. (2011): Evaluating the stability of the classification
          of community data. <i>Ecography</i> 34: 807–813.
        </li>
      </div>
    </div>
  )
};
